var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataAdded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-fill-out",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-fill-out:not(.animated) .animable{opacity:0}svg#freepik_stories-fill-out.animated #freepik--clip--inject-149,svg#freepik_stories-fill-out.animated #freepik--speech-bubble--inject-149{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-149",
    className: "animable",
    style: {
      transformOrigin: "249.998px 354.509px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-149",
    d: "M77.67 454c-95.18-54.95-95.18-144 0-199s249.49-54.95 344.66 0 95.18 144 0 199-249.49 55-344.66 0Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "249.998px 354.509px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-149",
    className: "animable",
    style: {
      transformOrigin: "243.104px 390.47px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-149",
    d: "m240.06 460.54-21.39-12.34c-2.39-1.38-2.39-3.62 0-5l36.25-20.94a9.52 9.52 0 0 1 8.65 0l21.19 12.43c2.38 1.39 2.37 3.65 0 5l-36 20.79a9.51 9.51 0 0 1-8.7.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "251.709px 441.392px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-149",
    d: "M88.55 432.55a12 12 0 0 1-1.91 4.45 21.11 21.11 0 0 1-7.16 6.36c-12.39 7.15-32.48 7.15-44.87 0a21.11 21.11 0 0 1-7.16-6.36 12 12 0 0 1-1.89-4.44c-1.11-5.38 1.92-11 9.06-15.1 12.39-7.17 32.48-7.17 44.87 0 7.13 4.11 10.16 9.71 9.06 15.09Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "57.0533px 430.402px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "166.665px 390.47px"
    },
    className: "animable",
    d: "m91.51 466.69-56.86-32.83 207.16-119.61 56.87 32.83L91.51 466.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55 457.74c26.82 5.26 104.64 6.45 108.22-30.29 1.86-21.34-22.1-37.17-41.26-37.39-7.56-.09-20.08.55-21.07 9.42-1.63 14.63-16.64 16.52-32.85 16.52-9.65 0-25.84-.68-35.5-.19-7.62.38-18.34 2.94-23.55 8.84-12.18 13.84 19.19 27.82 46.01 33.09Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "382.354px 425.258px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-149",
    className: "animable",
    style: {
      transformOrigin: "307.802px 92.9462px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-149",
    className: "animable",
    style: {
      transformOrigin: "298.916px 76.1503px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.67 107.78a.9.9 0 0 1-.38-.86l.24-5.4a1.35 1.35 0 0 0-1.25-1.39 9.78 9.78 0 0 1-1.37-.24 2.16 2.16 0 0 0-2.09.59l-.77 1-.11 2.32a.93.93 0 0 0 .4.86Zm16.76-33.58c.79-6-1.84-9.83-6.07-9.51a11.41 11.41 0 0 1 .73 6.34c-.91 7-6.06 14.22-11.5 16.19a9.07 9.07 0 0 1-2.13.51c1.31 2.77 4 3.9 7.47 2.66 5.44-1.98 10.59-9.22 11.5-16.19Zm-27.21 31.62a1.49 1.49 0 0 1-.28-.24l-2.37-2.6a1.88 1.88 0 0 1-.21-2.12l3.58-5.8a2.66 2.66 0 0 0 .33-1 3.65 3.65 0 0 0-.07-1.37 17.27 17.27 0 0 1-.48-2.17 1.17 1.17 0 0 0-1.43-1l-3.29.68a2.92 2.92 0 0 1 0 .66 2.67 2.67 0 0 1-.33 1L276 97.69a1.86 1.86 0 0 0 .21 2.12l2.37 2.6a1.13 1.13 0 0 0 .3.24Zm34.86-43.66a1 1 0 0 0-.72-.1l-.5.11a3.21 3.21 0 0 0 .1.72 15.67 15.67 0 0 1 .48 2.17 1.16 1.16 0 0 0 1.43 1l3.83-.87a.93.93 0 0 1 .6 0Zm-40.34 28.07a.9.9 0 0 1-.39-1l.83-6.42a2.76 2.76 0 0 1 .71-1.4 2 2 0 0 1 .65-.52l4.27-2.12a3.56 3.56 0 0 0 1.6-1.84c.43-1.22.93-2.43 1.47-3.61a2.55 2.55 0 0 0 .17-1.41 2.15 2.15 0 0 0-.32-.92l-1.79-2.79a2.11 2.11 0 0 1-.27-1.42A1.84 1.84 0 0 1 286 66l4.3-6a1.29 1.29 0 0 1 1.83-.26l2.3 1.77a1.61 1.61 0 0 0 2-.1 27.48 27.48 0 0 1 2.57-2.17 4.11 4.11 0 0 0 1.34-2.07v-.07l1.24-5.91a2.66 2.66 0 0 1 .74-1.25 2.11 2.11 0 0 1 .78-.51l4.62-1.68a.9.9 0 0 1 .74 0l-5.32-3.17a1 1 0 0 0-.76 0l-4.63 1.67a2.52 2.52 0 0 0-1.23 1.11 1.08 1.08 0 0 0-.16.3 1.58 1.58 0 0 0-.09.31L295 53.93V54a4 4 0 0 1-1.35 2.06 29.05 29.05 0 0 0-2.51 2.12 1.49 1.49 0 0 1-.85.39l-3.62-2.15a1.27 1.27 0 0 0-1.67.36l-4.33 6.09a2 2 0 0 0-.3.79 2.09 2.09 0 0 0 0 .56 1.26 1.26 0 0 0 0 .28 2.17 2.17 0 0 0 .07.24 1.08 1.08 0 0 0 .12.24v.07l1.79 2.79a1.13 1.13 0 0 1 .13.27.7.7 0 0 1 .08.2 2.21 2.21 0 0 1 .11.46 2.5 2.5 0 0 1-.17 1.4c-.54 1.18-1 2.39-1.47 3.61a3.71 3.71 0 0 1-1.6 1.85l-4.28 2.12a2.13 2.13 0 0 0-.63.52l-.13.15a3.47 3.47 0 0 0-.46.78 1.52 1.52 0 0 0-.06.2 1.22 1.22 0 0 0-.06.26l-.81 6.45a.94.94 0 0 0 .11.66.73.73 0 0 0 .27.28ZM317.47 50a1.1 1.1 0 0 1 1.42-.28l-5.36-3.18a1.1 1.1 0 0 0-1.41.28L308.75 51l-.14 3.09a1.35 1.35 0 0 0 1.27 1.38 8.58 8.58 0 0 1 1.36.23 2.16 2.16 0 0 0 2.1-.58Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "298.641px 76.1425px"
    },
    id: "elid9lhscz75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67 107.78a.9.9 0 0 1-.38-.86l.24-5.4a1.35 1.35 0 0 0-1.25-1.39 9.78 9.78 0 0 1-1.37-.24 2.16 2.16 0 0 0-2.09.59l-.77 1-.11 2.32a.93.93 0 0 0 .4.86Zm16.76-33.58c.79-6-1.84-9.83-6.07-9.51a11.41 11.41 0 0 1 .73 6.34c-.91 7-6.06 14.22-11.5 16.19a9.07 9.07 0 0 1-2.13.51c1.31 2.77 4 3.9 7.47 2.66 5.44-1.98 10.59-9.22 11.5-16.19Zm-27.21 31.62a1.49 1.49 0 0 1-.28-.24l-2.37-2.6a1.88 1.88 0 0 1-.21-2.12l3.58-5.8a2.66 2.66 0 0 0 .33-1 3.65 3.65 0 0 0-.07-1.37 17.27 17.27 0 0 1-.48-2.17 1.17 1.17 0 0 0-1.43-1l-3.29.68a2.92 2.92 0 0 1 0 .66 2.67 2.67 0 0 1-.33 1L276 97.69a1.86 1.86 0 0 0 .21 2.12l2.37 2.6a1.13 1.13 0 0 0 .3.24Zm34.86-43.66a1 1 0 0 0-.72-.1l-.5.11a3.21 3.21 0 0 0 .1.72 15.67 15.67 0 0 1 .48 2.17 1.16 1.16 0 0 0 1.43 1l3.83-.87a.93.93 0 0 1 .6 0Zm-40.34 28.07a.9.9 0 0 1-.39-1l.83-6.42a2.76 2.76 0 0 1 .71-1.4 2 2 0 0 1 .65-.52l4.27-2.12a3.56 3.56 0 0 0 1.6-1.84c.43-1.22.93-2.43 1.47-3.61a2.55 2.55 0 0 0 .17-1.41 2.15 2.15 0 0 0-.32-.92l-1.79-2.79a2.11 2.11 0 0 1-.27-1.42A1.84 1.84 0 0 1 286 66l4.3-6a1.29 1.29 0 0 1 1.83-.26l2.3 1.77a1.61 1.61 0 0 0 2-.1 27.48 27.48 0 0 1 2.57-2.17 4.11 4.11 0 0 0 1.34-2.07v-.07l1.24-5.91a2.66 2.66 0 0 1 .74-1.25 2.11 2.11 0 0 1 .78-.51l4.62-1.68a.9.9 0 0 1 .74 0l-5.32-3.17a1 1 0 0 0-.76 0l-4.63 1.67a2.52 2.52 0 0 0-1.23 1.11 1.08 1.08 0 0 0-.16.3 1.58 1.58 0 0 0-.09.31L295 53.93V54a4 4 0 0 1-1.35 2.06 29.05 29.05 0 0 0-2.51 2.12 1.49 1.49 0 0 1-.85.39l-3.62-2.15a1.27 1.27 0 0 0-1.67.36l-4.33 6.09a2 2 0 0 0-.3.79 2.09 2.09 0 0 0 0 .56 1.26 1.26 0 0 0 0 .28 2.17 2.17 0 0 0 .07.24 1.08 1.08 0 0 0 .12.24v.07l1.79 2.79a1.13 1.13 0 0 1 .13.27.7.7 0 0 1 .08.2 2.21 2.21 0 0 1 .11.46 2.5 2.5 0 0 1-.17 1.4c-.54 1.18-1 2.39-1.47 3.61a3.71 3.71 0 0 1-1.6 1.85l-4.28 2.12a2.13 2.13 0 0 0-.63.52l-.13.15a3.47 3.47 0 0 0-.46.78 1.52 1.52 0 0 0-.06.2 1.22 1.22 0 0 0-.06.26l-.81 6.45a.94.94 0 0 0 .11.66.73.73 0 0 0 .27.28ZM317.47 50a1.1 1.1 0 0 1 1.42-.28l-5.36-3.18a1.1 1.1 0 0 0-1.41.28L308.75 51l-.14 3.09a1.35 1.35 0 0 0 1.27 1.38 8.58 8.58 0 0 1 1.36.23 2.16 2.16 0 0 0 2.1-.58Z",
    style: {
      opacity: 0.1,
      transformOrigin: "298.641px 76.1425px"
    },
    className: "animable",
    id: "elfee4crlqvvp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.31 57.1 1.24-5.91a2.66 2.66 0 0 1 .74-1.25L297 46.77a3.29 3.29 0 0 0-.47.59 1.08 1.08 0 0 0-.16.3 1.58 1.58 0 0 0-.09.31L295 53.93Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "298.645px 51.935px"
    },
    id: "elann8ppxwfdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.05 72a2.15 2.15 0 0 0-.32-.92l-1.79-2.79a2.11 2.11 0 0 1-.27-1.42l-5.34-3.17a2.09 2.09 0 0 0 0 .56 1.26 1.26 0 0 0 0 .28 2.17 2.17 0 0 0 .07.24 1.08 1.08 0 0 0 .12.24v.07l1.79 2.79a1.13 1.13 0 0 1 .13.27 1.19 1.19 0 0 1 .08.2 3.12 3.12 0 0 1 .09.44Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "284.181px 67.85px"
    },
    id: "elanyj4o24esk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66 107.78a.89.89 0 0 1-.37-.86l.25-5.41a1.35 1.35 0 0 0-1.27-1.38 8.59 8.59 0 0 1-1.36-.24 2.17 2.17 0 0 0-2.1.6l-.76.94-.11 2.32a.9.9 0 0 0 .4.86Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "291.797px 103.802px"
    },
    id: "elcs18wzzysis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22 105.82a1.49 1.49 0 0 1-.28-.24l-2.37-2.6a1.88 1.88 0 0 1-.21-2.12l3.58-5.8a2.66 2.66 0 0 0 .33-1l-5.35-3.16a2.67 2.67 0 0 1-.33 1L276 97.69a1.86 1.86 0 0 0 .21 2.12l2.37 2.6a1.13 1.13 0 0 0 .3.24Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "280.516px 98.36px"
    },
    id: "elxi47exc4per",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74 90.23a.9.9 0 0 1-.39-1l.83-6.42a2.76 2.76 0 0 1 .71-1.4l-5.34-3.17-.13.15a3.47 3.47 0 0 0-.46.78 1.52 1.52 0 0 0-.06.2 1.22 1.22 0 0 0-.06.26l-.84 6.48a.94.94 0 0 0 .11.66.73.73 0 0 0 .27.28Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "276.436px 84.235px"
    },
    id: "elm6tghjts44d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.59 104.38 1.26-6a4 4 0 0 1 1.35-2.07 32.26 32.26 0 0 0 2.51-2.11 1.6 1.6 0 0 1 2-.11l2.3 1.77a1.28 1.28 0 0 0 1.83-.26l4.33-6.09a2.14 2.14 0 0 0 0-2.21l-1.79-2.79a2.66 2.66 0 0 1-.15-2.33c.55-1.18 1-2.39 1.47-3.61a3.74 3.74 0 0 1 1.59-1.85l4.28-2.11a2.79 2.79 0 0 0 1.43-1.9l.83-6.43a.86.86 0 0 0-1.11-1l-3.83.87a1.18 1.18 0 0 1-1.44-1.05 17.3 17.3 0 0 0-.45-2.2 3.31 3.31 0 0 1 .26-2.4l3.57-5.8a1.86 1.86 0 0 0-.22-2.12l-2.4-2.58a1.12 1.12 0 0 0-1.74 0l-4.14 5.07a2.14 2.14 0 0 1-2.09.6 8.79 8.79 0 0 0-1.36-.24 1.36 1.36 0 0 1-1.27-1.43l.25-5.4a.82.82 0 0 0-1.17-.89l-4.62 1.68a2.62 2.62 0 0 0-1.51 1.75l-1.26 6a4 4 0 0 1-1.3 2.1 30.62 30.62 0 0 0-2.52 2.11 1.58 1.58 0 0 1-2 .1l-2.3-1.76a1.28 1.28 0 0 0-1.83.26L286 66a2.14 2.14 0 0 0 0 2.21l1.73 2.79a2.66 2.66 0 0 1 .15 2.33c-.55 1.18-1 2.39-1.47 3.61a3.74 3.74 0 0 1-1.59 1.85l-4.28 2.11a2.79 2.79 0 0 0-1.36 1.91l-.83 6.43a.86.86 0 0 0 1.11 1l3.83-.87a1.18 1.18 0 0 1 1.44 1 15.68 15.68 0 0 0 .47 2.17 3.4 3.4 0 0 1-.27 2.41l-3.57 5.79a1.86 1.86 0 0 0 .22 2.12l2.36 2.6a1.12 1.12 0 0 0 1.74 0l4.14-5.07a2.14 2.14 0 0 1 2.09-.6 8.79 8.79 0 0 0 1.36.24 1.36 1.36 0 0 1 1.27 1.39l-.25 5.4a.82.82 0 0 0 1.17.89l4.62-1.68a2.62 2.62 0 0 0 1.51-1.65Zm-1.66-14c-5.44 2-9.12-2.07-8.21-9s6.06-14.21 11.5-16.19 9.12 2.07 8.21 9-6.05 14.22-11.5 16.2Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "301.59px 77.71px"
    },
    id: "elaa9tomyulc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-149",
    className: "animable",
    style: {
      transformOrigin: "321.941px 116.086px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.61 141.23a.74.74 0 0 1-.3-.68l.2-4.31a1.09 1.09 0 0 0-1-1.11 7.51 7.51 0 0 1-1.09-.19 1.71 1.71 0 0 0-1.67.47l-.62.76-.08 1.85a.71.71 0 0 0 .32.68ZM332 114.46c.62-4.79-1.47-7.84-4.84-7.58a9.15 9.15 0 0 1 .58 5.05c-.73 5.55-4.83 11.34-9.17 12.91a7 7 0 0 1-1.7.4c1 2.21 3.23 3.12 6 2.13 4.28-1.58 8.38-7.37 9.13-12.91Zm-21.69 25.21a.79.79 0 0 1-.22-.19l-1.9-2.08a1.52 1.52 0 0 1-.17-1.69l2.86-4.62a2.08 2.08 0 0 0 .26-.82 2.86 2.86 0 0 0-.06-1.1 14.24 14.24 0 0 1-.37-1.73.94.94 0 0 0-1.15-.83l-2.66.61a2.27 2.27 0 0 1 0 .52 2.15 2.15 0 0 1-.27.81l-2.85 4.62a1.52 1.52 0 0 0 .17 1.7l1.85 2.13a1.33 1.33 0 0 0 .24.19Zm27.79-34.81a.74.74 0 0 0-.58-.08l-.39.09a2.53 2.53 0 0 0 .08.57 12.55 12.55 0 0 1 .38 1.73.93.93 0 0 0 1.14.83l3.05-.69a.7.7 0 0 1 .48 0Zm-32.17 22.38a.73.73 0 0 1-.31-.76l.67-5.12a2.18 2.18 0 0 1 .56-1.11 1.82 1.82 0 0 1 .52-.42l3.41-1.68a2.93 2.93 0 0 0 1.27-1.48c.35-1 .74-1.93 1.17-2.87a2.09 2.09 0 0 0 .14-1.12 2 2 0 0 0-.25-.74l-1.44-2.22a1.72 1.72 0 0 1-.21-1.14 1.59 1.59 0 0 1 .24-.63l3.45-4.85a1 1 0 0 1 1.46-.21l1.83 1.41a1.29 1.29 0 0 0 1.61-.08 23.88 23.88 0 0 1 2-1.69 3.24 3.24 0 0 0 1.08-1.65l1-4.72a2.09 2.09 0 0 1 .59-1 1.67 1.67 0 0 1 .62-.41l3.66-1.38a.73.73 0 0 1 .6 0l-4.24-2.52a.75.75 0 0 0-.61 0l-3.69 1.34a1.93 1.93 0 0 0-1 .88.7.7 0 0 0-.13.24 1 1 0 0 0-.08.24l-1 4.72v.06a3.21 3.21 0 0 1-1.08 1.64 23.88 23.88 0 0 0-2 1.69 1.29 1.29 0 0 1-.68.31l-2.88-1.71a1 1 0 0 0-1.34.28l-3.44 4.86a1.48 1.48 0 0 0-.25.62 2.26 2.26 0 0 0 0 .45 1.57 1.57 0 0 0 0 .23l.06.19.09.2 1.42 2.22a1.06 1.06 0 0 1 .11.21.85.85 0 0 1 .06.17 1.9 1.9 0 0 1 .09.36 2.07 2.07 0 0 1-.13 1.12 30 30 0 0 0-1.18 2.88 3 3 0 0 1-1.27 1.47l-3.41 1.69a1.78 1.78 0 0 0-.51.42l-.11.12a2.62 2.62 0 0 0-.36.62 1 1 0 0 0-.05.16.8.8 0 0 0-.05.21l-.67 5.12a.82.82 0 0 0 .09.53.69.69 0 0 0 .22.23Zm30.87-32.07a.86.86 0 0 1 1.12-.23l-4.27-2.53a.86.86 0 0 0-1.12.22l-2.69 3.29-.11 2.46a1.08 1.08 0 0 0 1 1.1 7.61 7.61 0 0 1 1.08.19 1.72 1.72 0 0 0 1.68-.47Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "321.759px 116.008px"
    },
    id: "elqx371109oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61 141.23a.74.74 0 0 1-.3-.68l.2-4.31a1.09 1.09 0 0 0-1-1.11 7.51 7.51 0 0 1-1.09-.19 1.71 1.71 0 0 0-1.67.47l-.62.76-.08 1.85a.71.71 0 0 0 .32.68ZM332 114.46c.62-4.79-1.47-7.84-4.84-7.58a9.15 9.15 0 0 1 .58 5.05c-.73 5.55-4.83 11.34-9.17 12.91a7 7 0 0 1-1.7.4c1 2.21 3.23 3.12 6 2.13 4.28-1.58 8.38-7.37 9.13-12.91Zm-21.69 25.21a.79.79 0 0 1-.22-.19l-1.9-2.08a1.52 1.52 0 0 1-.17-1.69l2.86-4.62a2.08 2.08 0 0 0 .26-.82 2.86 2.86 0 0 0-.06-1.1 14.24 14.24 0 0 1-.37-1.73.94.94 0 0 0-1.15-.83l-2.66.61a2.27 2.27 0 0 1 0 .52 2.15 2.15 0 0 1-.27.81l-2.85 4.62a1.52 1.52 0 0 0 .17 1.7l1.85 2.13a1.33 1.33 0 0 0 .24.19Zm27.79-34.81a.74.74 0 0 0-.58-.08l-.39.09a2.53 2.53 0 0 0 .08.57 12.55 12.55 0 0 1 .38 1.73.93.93 0 0 0 1.14.83l3.05-.69a.7.7 0 0 1 .48 0Zm-32.17 22.38a.73.73 0 0 1-.31-.76l.67-5.12a2.18 2.18 0 0 1 .56-1.11 1.82 1.82 0 0 1 .52-.42l3.41-1.68a2.93 2.93 0 0 0 1.27-1.48c.35-1 .74-1.93 1.17-2.87a2.09 2.09 0 0 0 .14-1.12 2 2 0 0 0-.25-.74l-1.44-2.22a1.72 1.72 0 0 1-.21-1.14 1.59 1.59 0 0 1 .24-.63l3.45-4.85a1 1 0 0 1 1.46-.21l1.83 1.41a1.29 1.29 0 0 0 1.61-.08 23.88 23.88 0 0 1 2-1.69 3.24 3.24 0 0 0 1.08-1.65l1-4.72a2.09 2.09 0 0 1 .59-1 1.67 1.67 0 0 1 .62-.41l3.66-1.38a.73.73 0 0 1 .6 0l-4.24-2.52a.75.75 0 0 0-.61 0l-3.69 1.34a1.93 1.93 0 0 0-1 .88.7.7 0 0 0-.13.24 1 1 0 0 0-.08.24l-1 4.72v.06a3.21 3.21 0 0 1-1.08 1.64 23.88 23.88 0 0 0-2 1.69 1.29 1.29 0 0 1-.68.31l-2.88-1.71a1 1 0 0 0-1.34.28l-3.44 4.86a1.48 1.48 0 0 0-.25.62 2.26 2.26 0 0 0 0 .45 1.57 1.57 0 0 0 0 .23l.06.19.09.2 1.42 2.22a1.06 1.06 0 0 1 .11.21.85.85 0 0 1 .06.17 1.9 1.9 0 0 1 .09.36 2.07 2.07 0 0 1-.13 1.12 30 30 0 0 0-1.18 2.88 3 3 0 0 1-1.27 1.47l-3.41 1.69a1.78 1.78 0 0 0-.51.42l-.11.12a2.62 2.62 0 0 0-.36.62 1 1 0 0 0-.05.16.8.8 0 0 0-.05.21l-.67 5.12a.82.82 0 0 0 .09.53.69.69 0 0 0 .22.23Zm30.87-32.07a.86.86 0 0 1 1.12-.23l-4.27-2.53a.86.86 0 0 0-1.12.22l-2.69 3.29-.11 2.46a1.08 1.08 0 0 0 1 1.1 7.61 7.61 0 0 1 1.08.19 1.72 1.72 0 0 0 1.68-.47Z",
    style: {
      opacity: 0.1,
      transformOrigin: "321.759px 116.008px"
    },
    className: "animable",
    id: "elqli5o4nqq0g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.12 100.83 1-4.72a2.09 2.09 0 0 1 .59-1l-4.25-2.53a2.4 2.4 0 0 0-.37.47.7.7 0 0 0-.13.24 1 1 0 0 0-.08.24l-1 4.72Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "321.795px 96.705px"
    },
    id: "eljhtue1wfqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34 112.68a2 2 0 0 0-.25-.74l-1.44-2.22a1.72 1.72 0 0 1-.21-1.14l-4.26-2.53a2.26 2.26 0 0 0 0 .45 1.57 1.57 0 0 0 0 .23l.06.19.09.2 1.42 2.22a1.06 1.06 0 0 1 .11.21l.06.17a3.59 3.59 0 0 1 .08.35Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "310.254px 109.365px"
    },
    id: "eld30ns88lllj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61 141.23a.72.72 0 0 1-.3-.68l.2-4.31a1.07 1.07 0 0 0-1-1.11 6.42 6.42 0 0 1-1.08-.19 1.7 1.7 0 0 0-1.67.48l-.61.75-.09 1.84a.7.7 0 0 0 .32.69Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "316.332px 138.057px"
    },
    id: "elv2capxq86u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.29 139.67a.79.79 0 0 1-.22-.19l-1.9-2.08a1.52 1.52 0 0 1-.17-1.69l2.86-4.62a2.08 2.08 0 0 0 .26-.82l-4.26-2.52a2.15 2.15 0 0 1-.27.81l-2.85 4.62a1.52 1.52 0 0 0 .17 1.7l1.89 2.12a1.33 1.33 0 0 0 .24.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "307.338px 133.71px"
    },
    id: "elegl24uai00o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91 127.24a.73.73 0 0 1-.31-.76l.67-5.12a2.18 2.18 0 0 1 .56-1.11l-4.25-2.53-.11.12a2.62 2.62 0 0 0-.36.62 1 1 0 0 0-.05.16.8.8 0 0 0-.05.21l-.67 5.12a.82.82 0 0 0 .09.53.69.69 0 0 0 .22.23Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "304.079px 122.48px"
    },
    id: "elwlht04w3lf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.14 138.52 1-4.78a3.19 3.19 0 0 1 1.07-1.64 24 24 0 0 0 2-1.69 1.27 1.27 0 0 1 1.6-.08l1.83 1.4a1 1 0 0 0 1.46-.2l3.45-4.86a1.69 1.69 0 0 0 0-1.76l-1.43-2.22a2.14 2.14 0 0 1-.12-1.86c.43-.94.83-1.91 1.17-2.88a3 3 0 0 1 1.27-1.47l3.41-1.69a2.2 2.2 0 0 0 1.08-1.52l.67-5.12a.69.69 0 0 0-.89-.83l-3.05.69a.94.94 0 0 1-1.15-.83 12.56 12.56 0 0 0-.37-1.73 2.71 2.71 0 0 1 .21-1.92l2.85-4.61a1.52 1.52 0 0 0-.17-1.7l-1.89-2.07a.89.89 0 0 0-1.39 0l-3.29 4a1.72 1.72 0 0 1-1.68.47 7.61 7.61 0 0 0-1.08-.19 1.08 1.08 0 0 1-1-1.1l.2-4.31a.66.66 0 0 0-.94-.71l-3.68 1.34a2.11 2.11 0 0 0-1.2 1.4l-1 4.77a3.17 3.17 0 0 1-1.08 1.65 23.88 23.88 0 0 0-2 1.69 1.29 1.29 0 0 1-1.61.08l-1.83-1.41a1 1 0 0 0-1.46.21l-3.42 4.96a1.71 1.71 0 0 0 0 1.77l1.42 2.22a2.14 2.14 0 0 1 .13 1.86c-.44.94-.83 1.9-1.18 2.88a3 3 0 0 1-1.27 1.47l-3.41 1.69a2.19 2.19 0 0 0-1.08 1.52l-.67 5.12a.7.7 0 0 0 .89.83l3.05-.7a.94.94 0 0 1 1.15.84 15.1 15.1 0 0 0 .37 1.73 2.62 2.62 0 0 1-.21 1.91l-2.87 4.57a1.48 1.48 0 0 0 .17 1.69l1.88 2.08a.89.89 0 0 0 1.39 0l3.3-4a1.73 1.73 0 0 1 1.67-.48 6.42 6.42 0 0 0 1.08.19 1.07 1.07 0 0 1 1 1.11l-.2 4.31a.66.66 0 0 0 .94.71l3.68-1.34a2.12 2.12 0 0 0 1.23-1.46Zm-1.33-11.15c-4.34 1.57-7.27-1.65-6.54-7.2s4.82-11.34 9.16-12.91 7.27 1.65 6.55 7.2-4.83 11.33-9.17 12.91Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "324.112px 117.315px"
    },
    id: "el5yj7iuu3nxx",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-149",
    className: "animable",
    style: {
      transformOrigin: "97.285px 123.955px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-149",
    className: "animable",
    style: {
      transformOrigin: "62.09px 144.4px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-149",
    className: "animable",
    style: {
      transformOrigin: "62.09px 144.4px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "62.11px 207.725px"
    },
    id: "el7ff7ozlfydi",
    className: "animable",
    d: "m33.4 222.74 2.67 1.59 54.75-31.62-2.66-1.59-54.76 31.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "62.115px 144.39px"
    },
    id: "el77wg52rt775",
    className: "animable",
    d: "m88.16 191.12-52.09 30.07V97.64l52.09-30.05v123.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86 57.3 31 94.73v138.32l64.83-37.43Zm-5 135.41-54.79 31.62V97.64L90.82 66Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "63.43px 145.175px"
    },
    id: "elv21mg6qssg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "89.495px 129.37px"
    },
    id: "elfw7qcgzbp6m",
    className: "animable",
    d: "m90.82 192.71-2.66-1.59V67.59l2.67-1.56-.01 126.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "62.09px 75.24px"
    },
    id: "elshj5xhvwjia",
    className: "animable",
    d: "m95.86 57.3-2.71-1.55-64.83 37.43 2.71 1.55L95.86 57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "29.675px 163.115px"
    },
    id: "elbndxt8w4vbc",
    className: "animable",
    d: "m28.32 93.18 2.71 1.55v138.32l-2.71-1.55V93.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-149",
    className: "animable",
    style: {
      transformOrigin: "62.11px 145.18px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "62.11px 145.18px"
    },
    id: "elm82gor7t58",
    className: "animable",
    d: "m84.25 188-44.28 25.57V102.35l44.28-25.56V188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-149",
    className: "animable",
    style: {
      transformOrigin: "62.11px 145.18px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "62.11px 145.18px"
    },
    id: "el5vwlq6r7j6k",
    className: "animable",
    d: "m84.25 188-44.28 25.57V102.35l44.28-25.56V188z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 169.38a41.8 41.8 0 0 0 6.33 0 80.16 80.16 0 0 0 21.57-4.69c5.36-2 10.71-4.55 16.38-4.7V188l-6 3.47A20.13 20.13 0 0 0 70 186.9c-8.53-2.24-17.28 2-26 3a35.84 35.84 0 0 1-4 .2Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "62.14px 175.73px"
    },
    id: "elchtkpbxfsub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 145.4c9.88-2.93 20-5.4 27.11-12.63 5.7-5.86 8.38-14 10.26-21.93s3.16-16.17 6.76-23.5l.12-.22v46c-.56.83-1.11 1.66-1.7 2.46-6.51 8.82-16.09 16.18-27 16.75-5.14.26-10.45-.94-15.55-.92Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "62.125px 119.743px"
    },
    id: "elscizh7jpy7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 126.65c7.6-6.7 11.67-17.45 9.81-27.47-.13-.74-.31-1.47-.5-2.21l17-9.83c-.07 1.12-.12 2.24-.16 3.36-.17 6.5 0 13.09-1.39 19.43A38.18 38.18 0 0 1 45.36 135a35.85 35.85 0 0 1-5.36 2.26Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "53.155px 112.2px"
    },
    id: "el0xb3t1d3xf9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-149",
    className: "animable",
    style: {
      transformOrigin: "137.33px 56.835px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-149",
    className: "animable",
    style: {
      transformOrigin: "137.33px 56.835px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "137.35px 77.13px"
    },
    id: "eluxjy4ojh6xk",
    className: "animable",
    d: "m112.76 89.98 2.29 1.37 46.89-27.08-2.29-1.36-46.89 27.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "137.35px 56.83px"
    },
    id: "eludjx2yf96w7",
    className: "animable",
    d: "m159.65 62.91-44.6 25.75V50.73L159.65 25v37.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.25 16.19-55.52 32.05v50.57l55.52-32Zm-4.31 48.08-46.89 27.08V50.73l46.89-27.08Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "138.49px 57.5px"
    },
    id: "el0qid5m3i5zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "160.795px 43.96px"
    },
    id: "elidnz90zg7w",
    className: "animable",
    d: "m161.94 64.27-2.29-1.36V25l2.29-1.35v40.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "137.33px 31.55px"
    },
    id: "elhg0b6a6syek",
    className: "animable",
    d: "m166.25 16.18-2.32-1.32-55.52 32.05 2.32 1.33 55.52-32.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "109.57px 72.86px"
    },
    id: "elijpahx0p9hj",
    className: "animable",
    d: "m108.41 46.91 2.32 1.33v50.57l-2.32-1.33V46.91z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "137.35px 64.6px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "137.35px 64.6px"
    },
    id: "elk0iram8uqme",
    className: "animable",
    d: "m157.91 61.51-41.12 23.75v-3.09l10.28-23.75 6.4 5.94-.88 5.5 12.78-25.92 12.54 14.48v3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.09 47a6.72 6.72 0 0 0-3 5.27c0 1.94 1.36 2.72 3 1.75a6.72 6.72 0 0 0 3-5.27c.04-1.98-1.32-2.75-3-1.75Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "133.09px 50.4997px"
    },
    id: "elx3e82r2yr9",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-149",
    className: "animable",
    style: {
      transformOrigin: "411.7px 131.48px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-149",
    className: "animable",
    style: {
      transformOrigin: "411.7px 131.48px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "411.685px 131.46px"
    },
    id: "eldmyd1op8ftk",
    className: "animable",
    d: "m354.11 159.47 115.15 66.48-.01-122.52-115.14-66.46v122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "411.68px 194.035px"
    },
    id: "elhteccaxofd",
    className: "animable",
    d: "m471.51 227.26-2.25 1.34-117.41-67.78 2.26-1.35 117.4 67.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59 163.28 473.52 236V101L347.59 28.27Zm4.26-127.63 117.4 67.78V228.6l-117.4-67.78Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "410.555px 132.135px"
    },
    id: "elu69hbxsrhtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "352.98px 98.235px"
    },
    id: "elu0xxpmmcorg",
    className: "animable",
    d: "m351.85 160.82 2.26-1.35V36.97l-2.26-1.32v125.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "411.7px 63.965px"
    },
    id: "elbnp2jnu86v5",
    className: "animable",
    d: "m347.59 28.27 2.29-1.31 125.93 72.7-2.29 1.31-125.93-72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "474.665px 167.82px"
    },
    id: "elcas76w7tguc",
    className: "animable",
    d: "m475.81 99.66-2.29 1.31v135.01l2.29-1.31V99.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "409.615px 96.73px"
    },
    id: "elli2t7qku5b",
    className: "animable",
    d: "M467.38 128.15v2.65L351.85 64.01l2.26-1.35 113.27 65.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "413.04px 132.915px"
    },
    id: "elliz99yxq9r",
    className: "animable",
    d: "m414.19 71.65-2.3-1.32V195.5l2.3-1.31V71.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "409.76px 131.69px"
    },
    id: "elf9gcmz9wgvt",
    className: "animable",
    d: "m407.63 67.88 4.26 2.45V195.5l-4.26-2.46V67.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "410.575px 100.495px"
    },
    id: "el5yg41eewjz4",
    className: "animable",
    d: "M351.85 64.01v4.91l117.45 68.06v-4.91L351.85 64.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "440.575px 114.73px"
    },
    id: "el6o6gykajh16",
    className: "animable",
    d: "m411.89 98.8 2.3-1.41 55.07 31.84v2.84L411.89 98.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-149",
    className: "animable",
    style: {
      transformOrigin: "57.0603px 387.068px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-149",
    className: "animable",
    style: {
      transformOrigin: "57.0603px 387.068px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-149",
    className: "animable",
    style: {
      transformOrigin: "57.0533px 408.51px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.58 404.11H28.51l5.9 24.58c.45 3 2.64 5.86 6.57 8.13 8.87 5.12 23.26 5.12 32.14 0 4.23-2.44 6.42-5.61 6.62-8.81Z",
    style: {
      fill: "#37474f",
      transformOrigin: "57.045px 422.385px"
    },
    id: "el0hncsw7yzngg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62 421a24.21 24.21 0 0 0 3.38-2.43l3.22-13.14a23.25 23.25 0 0 1-5.74 4.57c-12 7-31.34 7.12-43.78.57l1.45-5.86-.45-.62h-8.19l5.9 24.57c.45 3 2.64 5.86 6.57 8.13 6.32 3.65 15.43 4.68 23.37 3.13-14.22 1.06-24-5.15-25.44-10.88-.59-2.29-1.61-7.35-1.61-7.35 11.88 6.05 29.97 5.81 41.32-.69Z",
    style: {
      fill: "#263238",
      transformOrigin: "56.865px 422.354px"
    },
    id: "elifos2h8adlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55 396.84a11.94 11.94 0 0 1-1.91 4.43 21.11 21.11 0 0 1-7.16 6.36c-12.39 7.15-32.48 7.15-44.87 0a21.11 21.11 0 0 1-7.16-6.36 11.88 11.88 0 0 1-1.89-4.43c-1.11-5.38 1.92-11 9.06-15.11 12.39-7.16 32.48-7.16 44.87 0 7.13 4.13 10.16 9.73 9.06 15.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "57.0533px 394.676px"
    },
    id: "el7svgay4mkf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64 401.27a21.11 21.11 0 0 1-7.16 6.36c-12.39 7.15-32.48 7.15-44.87 0a21.11 21.11 0 0 1-7.16-6.36 11.88 11.88 0 0 1-1.89-4.43l1.4 9.67c.65 3.89 3.55 7.68 8.72 10.67 11.81 6.81 30.94 6.81 42.75 0 5.1-2.95 8-6.69 8.69-10.53l.08-.5 1.36-9.31a11.94 11.94 0 0 1-1.92 4.43Z",
    style: {
      fill: "#37474f",
      transformOrigin: "57.06px 409.564px"
    },
    id: "elwzpszrpts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74 383.89c-10.32-6-27.06-6-37.38 0-5.85 3.37-8.38 7.93-7.61 12.33.59 3.38 3.13 6.66 7.61 9.25 10.32 6 27.06 6 37.38 0 4.48-2.59 7-5.87 7.61-9.24.77-4.41-1.76-8.97-7.61-12.34Z",
    style: {
      fill: "#263238",
      transformOrigin: "57.05px 394.68px"
    },
    id: "els55b5vvqg9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.49 400.31a17.75 17.75 0 0 0 5.87 5.16c10.32 6 27.06 6 37.38 0a17.86 17.86 0 0 0 5.87-5.16c-.08-3.57-2.47-7.13-7.19-9.85-9.6-5.55-25.15-5.55-34.74 0-4.68 2.72-7.11 6.28-7.19 9.85Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "57.05px 398.134px"
    },
    id: "elqlma3q143wp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59 389.21c-4.74-1.29-5.54-11.56-2.89-22.41 2.59-10.56 10.87-26.38 12.63-26s3.95 17.55 2.72 28.9C70 383.43 63.77 390.5 59 389.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "63.2143px 365.077px"
    },
    id: "eluquj8y9kgwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 389.21c-4.74-1.29-5.54-11.56-2.89-22.41 2.59-10.56 10.87-26.38 12.63-26s3.95 17.55 2.72 28.9C70 383.43 63.77 390.5 59 389.21Z",
    style: {
      opacity: 0.3,
      transformOrigin: "63.2143px 365.077px"
    },
    className: "animable",
    id: "el2q4v4z69fq9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.34 356c.85 1.34 1.37 3.62 3.36 3.63 1.6 0 2.44-1.69 3.88-2.08a3.94 3.94 0 0 1 3.19 1l-.06-1.24a4.86 4.86 0 0 0-2.75-1 4 4 0 0 0-2.3 1c-.74.57-1.64 1.44-2.66 1s-1.48-1.92-2.08-2.89a3.65 3.65 0 0 0-1.26-1.3c-.13.29-.26.58-.38.88a2.68 2.68 0 0 1 1.06 1Zm5.66-4.26a6.79 6.79 0 0 0 1.61-1.51 2.3 2.3 0 0 1 2.44-.47h.08c0-.37-.09-.73-.13-1.08l-.46-.11a2.72 2.72 0 0 0-2 .43c-.65.47-1 1.28-1.71 1.7-1.24.74-2.23-.61-2.6-1.63-.16-.46-.29-.92-.44-1.38-.13.24-.26.48-.38.72.08.33.16.66.26 1 .4 1.34 1.67 3.1 3.33 2.33Zm-.15 13.73c-.87.52-1.6 1.41-2.6 1.69-2.44.7-3-3.07-4.56-4.19a3.29 3.29 0 0 0-2.22-.58c-.1.29-.19.58-.28.87a3 3 0 0 1 1.24 0 3.39 3.39 0 0 1 2.14 1.9c.78 1.4 1.77 3.41 3.73 3a6.17 6.17 0 0 0 2.27-1.28 4.1 4.1 0 0 1 3.31-.89 4.47 4.47 0 0 1 1.86 1l.06-1.12a4.66 4.66 0 0 0-2.27-1 4.08 4.08 0 0 0-2.72.6Zm1.49 8.29a4.84 4.84 0 0 0-3.24.42c-1.13.56-2 1.66-3.14 2.1-2.58 1-3-2.76-4.87-3.68a4 4 0 0 0-2-.38l-.12.88a3.76 3.76 0 0 1 .75 0 3.45 3.45 0 0 1 2.67 2.06c.91 1.7 2.11 3.09 4.2 2.07 1.12-.55 1.92-1.57 3.07-2.06a3.66 3.66 0 0 1 3.85.35 6.09 6.09 0 0 1 .73.89c.1-.36.19-.74.27-1.12a4.09 4.09 0 0 0-2.21-1.53Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.5,
      transformOrigin: "63.385px 362.634px"
    },
    className: "animable",
    id: "el5h5xl6e9vpt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 389.21c4.75 1.29 11-5.78 12.46-19.54a81.51 81.51 0 0 0 .26-11.8c-3.88 3.19-7.76 9.68-7.76 9.68a105.17 105.17 0 0 0-4.61-10.37 73.62 73.62 0 0 0-3.24 9.62c-2.63 10.85-1.83 21.12 2.89 22.41Z",
    style: {
      opacity: 0.1,
      transformOrigin: "63.2239px 373.27px"
    },
    className: "animable",
    id: "elo83mhswd3nn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16 394.91c-6.25 4-12.07-10.24-15.17-21s-1.08-38.86 2.07-40.4c2.23-1.09 14 24.1 16.33 36.37 1.68 8.86 1.73 21.84-3.23 25.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "48.9299px 364.538px"
    },
    id: "el1nkpzfw4rgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16 394.91c-6.25 4-12.07-10.24-15.17-21s-1.08-38.86 2.07-40.4c2.23-1.09 14 24.1 16.33 36.37 1.68 8.86 1.73 21.84-3.23 25.03Z",
    style: {
      opacity: 0.1,
      transformOrigin: "48.9299px 364.538px"
    },
    className: "animable",
    id: "elv1b0ozsshzf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.69 353.36c2 1 3.52 1 5.05-.68s2.46-3.48 4.68-3.23c-.21-.49-.43-1-.65-1.47a3.37 3.37 0 0 0-1.08.11c-1.93.52-2.8 2.53-4.16 3.81-2.09 2-4.32-.62-6.7-.47h-.21l-.06 1.29a6.09 6.09 0 0 1 3.13.64Zm17.15 19.34a8 8 0 0 0-1-.29 3.77 3.77 0 0 0-3 .67c-1.89 1.38-2 4.46-5 3.66-2.32-.62-4.07-2.15-6.5-.92a8.16 8.16 0 0 0-2.25 1.69l.36 1.07a6.93 6.93 0 0 1 3-1.89c2.63-.68 4.61 2 7.23 1.55 2.13-.36 2.36-2.7 3.84-3.86a3.34 3.34 0 0 1 3.46-.21c.02-.5-.07-.98-.14-1.47Zm-17-29.55c.73 1 1.75 2.12 3.11 1.42s1.55-2.5 2.49-3.65l-.51-1c-.91 1.21-1.35 3.84-3.09 3.74-1.35-.07-1.88-2.08-3-2.66a2 2 0 0 0-1.13-.22l-.12.83h.27c.88.05 1.43.85 1.94 1.54Zm4.7 21.34c2.46.54 3.67-2.4 4.78-4a7.25 7.25 0 0 1 3.42-2.89c-.17-.44-.33-.88-.5-1.33a5 5 0 0 0-1.29.48 8.36 8.36 0 0 0-2.67 2.72c-.74 1.11-1.36 2.59-2.51 3.34-1.32.86-2.86-.48-4.23-.73a7.33 7.33 0 0 0-3.8.31 6.1 6.1 0 0 0-1.15.56c0 .61.06 1.21.09 1.8a5.83 5.83 0 0 1 4-1.34c1.4 0 2.47.79 3.82 1.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "48.7714px 359.25px"
    },
    id: "el23pp8r34uj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.12 358.71a35.09 35.09 0 0 0-5.06 8.29s-6.78-9.19-11.54-13.35c-.26 7.63.12 15.59 1.47 20.27 3.1 10.76 8.92 25 15.17 21 5-3.19 4.91-16.17 3.23-25a77.85 77.85 0 0 0-3.27-11.21Z",
    style: {
      opacity: 0.1,
      transformOrigin: "48.934px 374.63px"
    },
    className: "animable",
    id: "el7u3zqyzqcq7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73 402.23c-11.41.62-22.08-6.29-29-15S13.41 360.52 15 359.41s20 10.25 26.9 18.44c9.03 10.75 12.83 24.38 12.83 24.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "34.7251px 380.802px"
    },
    id: "el1i9udg7dd6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73 402.23c-11.41.62-22.08-6.29-29-15S13.41 360.52 15 359.41s20 10.25 26.9 18.44c9.03 10.75 12.83 24.38 12.83 24.38Z",
    style: {
      opacity: 0.2,
      transformOrigin: "34.7251px 380.802px"
    },
    className: "animable",
    id: "el1pa17lpn9x5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.82 373.65c.66-1.08.28-2.37.14-3.53a3.25 3.25 0 0 1 .46-2.22l-1.29-.9a4.65 4.65 0 0 0-.47 3.09c.19 1.32.51 3-1.25 3.2-1.92.27-4.58-1.45-6.12.45-.74.92-.46 2.1-.48 3.17a3.15 3.15 0 0 1-.42 1.39c.21.44.42.87.64 1.29a4 4 0 0 0 .85-1.93c.16-1.33-.36-3 1.43-3.32 1.24-.2 2.43.37 3.66.46a2.91 2.91 0 0 0 2.85-1.15Zm-6.37-9.53a2.16 2.16 0 0 1 .5-.54l-1-.63c-.84 1.1-.84 2.61-1.69 3.71a1.94 1.94 0 0 1-2.15.61 3.66 3.66 0 0 0-2.38.08 3.72 3.72 0 0 0-.48.27c.09.27.17.55.26.83a2.5 2.5 0 0 1 1.2-.33c.86 0 1.67.43 2.54.37a2.24 2.24 0 0 0 1.51-.78c.92-1.02.96-2.46 1.69-3.59Zm12.64 15.29a5.55 5.55 0 0 0 1.74-2.94 19.27 19.27 0 0 0 .29-2.42l-1.08-1c-.23 1.34-.11 2.69-.8 4a3.57 3.57 0 0 1-3.55 1.86 3.73 3.73 0 0 0-3 1 5.73 5.73 0 0 0-1.14 3.06c-.23 1.59-.47 3.06-1.95 4a4.34 4.34 0 0 1-.79.37c.27.34.55.67.82 1a4.38 4.38 0 0 0 1.59-1.34c1.91-2.27.37-6.77 4.42-6.76a4.93 4.93 0 0 0 3.45-.83Zm6.14 1.15a5.64 5.64 0 0 1 .86-1.19q-.48-.63-1-1.23a7.43 7.43 0 0 0-1.83 3.59 10.79 10.79 0 0 1-1.47 4.27c-1 1.28-2.58 1.14-3.89 1.87a5.54 5.54 0 0 0-2.43 2.84 13 13 0 0 0-.61 2.88c.39.34.8.67 1.2 1a1 1 0 0 0 0-.17c.25-1.62.45-3.28 1.71-4.46s2.86-1 4.15-1.88c2.5-1.76 2.08-5.08 3.31-7.52Zm5 4.76a7.5 7.5 0 0 0-.93.85c-2 2.14-1.7 4.92-2.42 7.53a4.59 4.59 0 0 1-2.48 3.3c-1.08.45-2.31 0-3.26.87l-.09.11c.56.32 1.13.63 1.71.92a4.94 4.94 0 0 1 1-.11 4.31 4.31 0 0 0 1.77-.43 5 5 0 0 0 2.12-2.36c1.19-2.45.66-5.43 2.14-7.76a6.35 6.35 0 0 1 1.21-1.48q-.39-.76-.82-1.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "32.125px 380.925px"
    },
    id: "eldie9uybkn6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 366.92c1.07 9.44 6.11 34.87 25.7 35.31 0 0-3.8-13.63-12.86-24.38-2.91-3.47-7.91-7.51-12.84-10.93Z",
    style: {
      opacity: 0.2,
      transformOrigin: "41.85px 384.575px"
    },
    className: "animable",
    id: "elk9wk4a7iua"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73 402.23c-9-1.3-16.68-7-20.64-23.9s-4.57-24.54-1.84-26.22c3.13-1.94 15.38 15.11 19.32 22.61 9.9 18.83 3.16 27.51 3.16 27.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "43.7738px 377.094px"
    },
    id: "el3ifas3ycw6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.07 371c2.24.7 5.15 1.45 6.83-.76.82-1.08 1-2.55 1.62-3.69-.4-.57-.8-1.15-1.21-1.72-1 1.59-1 3.94-2.69 4.85-1.3.69-2.84.24-4.16-.16a9.83 9.83 0 0 0-4.12-.62 5.75 5.75 0 0 0-2.15.76l.32 1.54a6.07 6.07 0 0 1 .89-.43 6.89 6.89 0 0 1 4.67.23Zm-2.65-8.76a3.47 3.47 0 0 0 2.09.4c1.36-.28 2.07-1.6 2.77-2.66a5 5 0 0 1 .69-.89l-.85-1-.17.18c-.85 1-1.56 3.12-3.14 3.15a10.6 10.6 0 0 1-2.24-.65 5.27 5.27 0 0 0-1.94-.05 4.87 4.87 0 0 0-1.79.69c0 .39.1.8.15 1.21a5.43 5.43 0 0 1 2.41-.74 5 5 0 0 1 2.02.35Zm9.8 18.76c.86-1.25 1.47-2.67 2.74-3.58a6 6 0 0 1 4.58-.81c-.31-.63-.62-1.26-1-1.91a7.48 7.48 0 0 0-3.11.2 6.55 6.55 0 0 0-3.42 2.5 19.55 19.55 0 0 1-2.3 3.31c-1.83 1.67-4.3.21-6.34-.19a7.18 7.18 0 0 0-1.79-.14c.16.59.32 1.16.49 1.73a7.49 7.49 0 0 1 2.36.36c3.09.97 5.75 1.53 7.79-1.47Zm10.34 3.29a4.61 4.61 0 0 0-.46.13 7 7 0 0 0-3 2.28c-.87 1.12-1.33 2.49-2.15 3.64a2.82 2.82 0 0 1-3.57 1.19 6.11 6.11 0 0 0-4-.29 6.48 6.48 0 0 0-2.5 1.56c.31.46.62.88.94 1.29a5.29 5.29 0 0 1 1.94-1.09 4.31 4.31 0 0 1 3.09.38 4.83 4.83 0 0 0 6.35-1.93c.77-1.12 1.22-2.46 2.08-3.52a5.08 5.08 0 0 1 1.85-1.42c-.13-.72-.35-1.44-.57-2.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "43.485px 376.09px"
    },
    className: "animable",
    id: "elfe2eh2x0zj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.57 374.72c-.71-1.36-1.7-3-2.85-4.85-3.88 12-5.13 29.52 6 32.36.01 0 6.75-8.68-3.15-27.51Z",
    style: {
      opacity: 0.15,
      transformOrigin: "51.4574px 386.05px"
    },
    className: "animable",
    id: "elv1b0bvh0ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.37 402.23c11.41.62 22.08-6.29 29-15s12.32-26.71 10.76-27.82-20 10.25-26.89 18.44c-9.08 10.75-12.87 24.38-12.87 24.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "79.3852px 380.802px"
    },
    id: "eljlrcoaq6ek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.37 402.23c11.41.62 22.08-6.29 29-15s12.32-26.71 10.76-27.82-20 10.25-26.89 18.44c-9.08 10.75-12.87 24.38-12.87 24.38Z",
    style: {
      opacity: 0.2,
      transformOrigin: "79.3852px 380.802px"
    },
    className: "animable",
    id: "eldfiyla7ugla"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.13 374.79c1.22-.09 2.42-.66 3.66-.46 1.79.28 1.27 2 1.43 3.32a3.88 3.88 0 0 0 .85 1.93c.21-.42.43-.85.63-1.29a3 3 0 0 1-.41-1.39c0-1.07.26-2.25-.49-3.17-1.54-1.9-4.19-.18-6.11-.45-1.76-.24-1.45-1.88-1.26-3.2A4.64 4.64 0 0 0 85 367l-1.29.91a3.25 3.25 0 0 1 .46 2.22c-.15 1.16-.53 2.45.14 3.53a2.91 2.91 0 0 0 2.82 1.13Zm5.23-7.08a2.24 2.24 0 0 0 1.51.78c.87.06 1.67-.4 2.54-.37a2.46 2.46 0 0 1 1.19.33c.09-.28.18-.56.26-.83a3.59 3.59 0 0 0-.47-.27 3.66 3.66 0 0 0-2.38-.08 1.93 1.93 0 0 1-2.15-.61c-.85-1.1-.85-2.61-1.69-3.71l-1 .63a2.19 2.19 0 0 1 .51.54c.7 1.13.74 2.57 1.68 3.59Zm-10.91 12.57c4.06 0 2.51 4.49 4.42 6.76a4.55 4.55 0 0 0 1.64 1.21c.28-.32.56-.65.83-1a4 4 0 0 1-.79-.37c-1.48-.9-1.72-2.37-2-4a5.81 5.81 0 0 0-1.14-3.06 3.77 3.77 0 0 0-3.06-1 3.58 3.58 0 0 1-3.5-1.82c-.69-1.26-.56-2.61-.8-4l-1.08 1a21.33 21.33 0 0 0 .3 2.42 5.6 5.6 0 0 0 1.73 2.99 4.94 4.94 0 0 0 3.45.87Zm-6.32 7.77c1.29.91 3 .74 4.16 1.88s1.45 2.84 1.71 4.46v.17c.41-.32.81-.65 1.21-1a14.2 14.2 0 0 0-.61-2.88 5.54 5.54 0 0 0-2.43-2.84c-1.32-.73-2.9-.59-3.89-1.87a10.65 10.65 0 0 1-1.49-4.25 7.33 7.33 0 0 0-1.79-3.58q-.51.6-1 1.23a5.27 5.27 0 0 1 .85 1.19c1.25 2.44.83 5.76 3.28 7.49Zm-9.06-1.29a6.14 6.14 0 0 1 1.24 1.43c1.48 2.33 1 5.31 2.13 7.76a5 5 0 0 0 2.17 2.37 4.4 4.4 0 0 0 1.78.43 5 5 0 0 1 1 .11c.57-.29 1.14-.6 1.71-.92 0 0-.06-.08-.09-.11-.95-.85-2.18-.42-3.27-.87a4.62 4.62 0 0 1-2.43-3.26c-.71-2.61-.47-5.39-2.42-7.53a7.41 7.41 0 0 0-.92-.85c-.34.48-.62.96-.9 1.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "81.965px 380.905px"
    },
    id: "elp6criwvt3z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07 366.92c-1.07 9.44-6.07 34.87-25.7 35.31 0 0 3.79-13.63 12.86-24.38 2.93-3.47 7.93-7.51 12.84-10.93Z",
    style: {
      opacity: 0.2,
      transformOrigin: "72.22px 384.575px"
    },
    className: "animable",
    id: "elct9pzthg9q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.37 402.23c9-1.3 16.68-7 20.64-23.9s4.56-24.54 1.84-26.22c-3.14-1.94-15.39 15.11-19.33 22.61-9.9 18.83-3.15 27.51-3.15 27.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.321px 377.094px"
    },
    id: "elh8hf3czt4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.69 370.76a6.18 6.18 0 0 1 .9.43l.32-1.54a5.87 5.87 0 0 0-2.15-.76 9.88 9.88 0 0 0-4.13.62c-1.31.4-2.85.85-4.15.16-1.73-.91-1.71-3.26-2.7-4.85-.4.57-.81 1.15-1.2 1.72.57 1.14.8 2.61 1.62 3.69 1.67 2.21 4.59 1.46 6.82.76a6.89 6.89 0 0 1 4.67-.23Zm0-8.91a5.43 5.43 0 0 1 2.41.74c0-.41.1-.82.15-1.21a4.85 4.85 0 0 0-1.8-.69 5.22 5.22 0 0 0-1.93.05 10.77 10.77 0 0 1-2.24.65c-1.58 0-2.3-2.13-3.15-3.15a1.45 1.45 0 0 0-.17-.18l-.84 1a5.56 5.56 0 0 1 .69.89c.69 1.06 1.41 2.38 2.77 2.66a3.44 3.44 0 0 0 2.08-.4 5.05 5.05 0 0 1 2.04-.36Zm-4.07 20.64a7.45 7.45 0 0 1 2.36-.36c.16-.57.33-1.14.48-1.73a7.25 7.25 0 0 0-1.79.14c-2 .4-4.51 1.86-6.34.19a19.5 19.5 0 0 1-2.29-3.31 6.58 6.58 0 0 0-3.43-2.5 7.43 7.43 0 0 0-3.1-.2c-.34.65-.66 1.28-1 1.91a6 6 0 0 1 4.58.81c1.26.91 1.88 2.33 2.74 3.58 2.09 2.98 4.75 2.42 7.8 1.47ZM58 386.5a5.11 5.11 0 0 1 1.86 1.42c.86 1.06 1.3 2.4 2.07 3.52a4.84 4.84 0 0 0 6.36 1.93 4.31 4.31 0 0 1 3.09-.38 5.29 5.29 0 0 1 1.93 1.12c.31-.41.63-.83.93-1.29a6.41 6.41 0 0 0-2.5-1.56 6.08 6.08 0 0 0-3.94.29 2.82 2.82 0 0 1-3.57-1.19c-.83-1.15-1.29-2.52-2.16-3.64a7 7 0 0 0-3-2.28 3.81 3.81 0 0 0-.45-.13c-.3.76-.49 1.48-.62 2.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "70.625px 376.085px"
    },
    className: "animable",
    id: "ell11o4xdugam"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.52 374.72c.72-1.36 1.7-3 2.86-4.85 3.88 12 5.13 29.52-6 32.36-.01 0-6.76-8.68 3.14-27.51Z",
    style: {
      opacity: 0.15,
      transformOrigin: "62.6395px 386.05px"
    },
    className: "animable",
    id: "elze5jvt56alp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.05 404.1c7.57 0 10.09-10.31 9.33-18.6s-6-24.08-9.33-24.08-8.58 15.78-9.33 24.08 1.76 18.6 9.33 18.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "57.0513px 382.76px"
    },
    id: "el0ni1mvtrkloe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.05 404.1c7.57 0 10.09-10.31 9.33-18.6s-6-24.08-9.33-24.08-8.58 15.78-9.33 24.08 1.76 18.6 9.33 18.6Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "57.0513px 382.76px"
    },
    className: "animable",
    id: "eleuewooz8gxf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 372.21c1.21-.24 2-1.22 2.82-2a4.84 4.84 0 0 1 2.34-1.21c-.19-.5-.39-1-.59-1.44a7.18 7.18 0 0 0-3.19 2 4.61 4.61 0 0 1-1.58 1.19c-.92.32-1.48-.18-2.08-.78a5 5 0 0 0-2.49-1.49h-.08c-.15.39-.31.79-.46 1.2a4.69 4.69 0 0 1 2.63 1.48 2.83 2.83 0 0 0 2.68 1.05Zm-5.65 9.09c2.53 2 4.61-.83 6.22-2.49 1.35-1.4 2.78-1.68 4.31-.4a9.84 9.84 0 0 0 2.88 2.09 5 5 0 0 0 .87.22c-.1-.47-.2-1-.31-1.43a8.62 8.62 0 0 1-3.07-2.05c-2.26-1.85-4.29-1.08-6.07 1-1 1.18-2.7 3.21-4.39 2-1-.75-1.47-2-2.51-2.74-.11.41-.21.83-.31 1.24.94.56 1.44 1.83 2.38 2.56Zm2.83 9.08c1.43 1.89 3.22 2.36 5.15.73 1-.79 1.57-1.91 2.6-2.61 1.44-1 3.09-.47 4.58.11v-1.34a10.34 10.34 0 0 0-2.11-.66 4.27 4.27 0 0 0-3.26.66c-1.07.76-1.73 2-2.76 2.75a2.58 2.58 0 0 1-2.19.7c-.86-.32-1.38-1.4-2-2a6.31 6.31 0 0 0-2.96-1.72 5.38 5.38 0 0 0-3.62.37v1.29a5.33 5.33 0 0 1 6.57 1.72Zm7.19 7.71a6 6 0 0 1-4.28 1.29 3.42 3.42 0 0 1-2.15-.94c-.42-.43-.72-1-1.15-1.39a5 5 0 0 0-2.85-1.41 5.41 5.41 0 0 0-2.37.2c.13.46.27.91.43 1.36a3.9 3.9 0 0 1 3.77.52c.91.67 1.35 1.78 2.31 2.41a5.36 5.36 0 0 0 3 .76 6.6 6.6 0 0 0 3.14-.77c1.09-.57 1.87-1.56 2.92-2.17a4.92 4.92 0 0 1 .88-.39c.21-.56.39-1.13.56-1.72a5.42 5.42 0 0 0-1.06.22 10.66 10.66 0 0 0-3.15 2.03Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "57.06px 384.228px"
    },
    className: "animable",
    id: "elln69j5lbg3q"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-149",
    className: "animable animator-active",
    style: {
      transformOrigin: "184.85px 238.59px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clipboard--inject-149",
    className: "animable",
    style: {
      transformOrigin: "184.85px 238.59px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-149",
    className: "animable",
    style: {
      transformOrigin: "184.85px 238.59px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "184.85px 238.59px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m276.26 19.62-190.7 110a7.89 7.89 0 0 0-3.56 6.15V451a7.85 7.85 0 0 0 3.57 6.17l.73.41a7.91 7.91 0 0 0 7.14 0l190.7-110.14a7.88 7.88 0 0 0 3.56-6.18V26.19a7.85 7.85 0 0 0-3.57-6.19l-.73-.41a7.91 7.91 0 0 0-7.14.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "184.85px 238.592px"
    },
    id: "el6029zvtmpmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.26 19.62-190.7 110a7.89 7.89 0 0 0-3.56 6.15V451a7.85 7.85 0 0 0 3.57 6.17l.73.41a7.91 7.91 0 0 0 7.14 0l190.7-110.14a7.88 7.88 0 0 0 3.56-6.18V26.19a7.85 7.85 0 0 0-3.57-6.19l-.73-.41a7.91 7.91 0 0 0-7.14.03Z",
    style: {
      opacity: 0.45,
      transformOrigin: "184.85px 238.592px"
    },
    className: "animable",
    id: "ely7fmh09rmzp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 341.52c0 3.13-2.2 5.13-4.93 6.7l-188 108.53c-2.71 1.56-4.93.3-4.93-2.85V141.82a9.8 9.8 0 0 1 4.91-8.5l188-108.57a3.28 3.28 0 0 1 4.93 2.84Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.77px 240.862px"
    },
    id: "elnkn7zjcpowq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 341.52c0 3.13-2.2 5.13-4.93 6.7l-188 108.53c-2.71 1.56-4.93.3-4.93-2.85V141.82a9.8 9.8 0 0 1 4.91-8.5l188-108.57a3.28 3.28 0 0 1 4.93 2.84Z",
    style: {
      opacity: 0.3,
      transformOrigin: "188.77px 240.862px"
    },
    className: "animable",
    id: "el67es25kltff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 26.19v1.4a3.29 3.29 0 0 0-4.94-2.84l-188 108.57a9.56 9.56 0 0 0-3.58 3.59l-.06.1-8.12-4.69a7.24 7.24 0 0 1 2.56-2.72l190.7-110a7.91 7.91 0 0 1 7.14 0l.72.41a7.84 7.84 0 0 1 3.58 6.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "185.35px 77.8793px"
    },
    id: "el4euxxbsugvw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7 26.19v1.4a3.29 3.29 0 0 0-4.94-2.84l-188 108.57a9.56 9.56 0 0 0-3.58 3.59l-.06.1-8.12-4.69a7.24 7.24 0 0 1 2.56-2.72l190.7-110a7.91 7.91 0 0 1 7.14 0l.72.41a7.84 7.84 0 0 1 3.58 6.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "185.35px 77.8793px"
    },
    className: "animable",
    id: "elydggzd989r9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M283.05 334.25c0 3.23-2.26 5.29-5.07 6.9L100.31 443.73c-2.8 1.61-5.08.31-5.08-2.93V160a10.11 10.11 0 0 1 5-8.75L278 48.62a3.39 3.39 0 0 1 5.08 2.93v282.7Z",
    style: {
      opacity: 0.25,
      transformOrigin: "189.155px 246.294px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-149",
    className: "animable",
    style: {
      transformOrigin: "190.68px 248.796px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-149",
    className: "animable",
    style: {
      transformOrigin: "190.68px 248.796px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.78 155.09 177-102.2a3.31 3.31 0 0 1 3 0l1.71 1a3.36 3.36 0 0 1 1.51 2.63v283.4a3.36 3.36 0 0 1-1.51 2.62l-177 102.21a3.37 3.37 0 0 1-3 0l-1.71-1a3.36 3.36 0 0 1-1.52-2.63V157.71a3.34 3.34 0 0 1 1.52-2.62Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "190.63px 248.816px"
    },
    id: "elatgbt176rac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16 444.91a2.56 2.56 0 0 1-.56.15h-.29a4.14 4.14 0 0 1-.93 0 2.73 2.73 0 0 1-.56-.15 3.36 3.36 0 0 1-.33-.16l-1.71-1a3.35 3.35 0 0 1-1.51-2.63v-283.4a3 3 0 0 1 .44-1.49l4.74 2.73a3.17 3.17 0 0 0-.45 1.49v283.42c0 .83.49 1.24 1.16 1.04Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "101.215px 300.658px"
    },
    id: "elrasa9ezqjop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.54 53.87-1.71-1a3.31 3.31 0 0 0-3 0l-177 102.2a3.34 3.34 0 0 0-1.52 2.62v19.11l4.74 2.76 180.05-104V56.5a3.36 3.36 0 0 0-1.56-2.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "190.705px 116.035px"
    },
    id: "elw0uuukzjb1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.54 53.87-1.71-1a3.31 3.31 0 0 0-3 0l-177 102.2a3.34 3.34 0 0 0-1.52 2.62v19.11l4.74 2.76 180.05-104V56.5a3.36 3.36 0 0 0-1.56-2.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "190.705px 116.035px"
    },
    className: "animable",
    id: "el25jlzhqd2nci"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 56c-.19-.62-.77-.82-1.46-.42l-177 102.2a3.07 3.07 0 0 0-1.07 1.13l-4.74-2.73a3.07 3.07 0 0 1 1.07-1.13l177-102.2a3.31 3.31 0 0 1 3 0l1.71 1A3.37 3.37 0 0 1 283 56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "190.865px 105.7px"
    },
    id: "elppxl4s7h3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 56c-.19-.62-.77-.82-1.46-.42l-177 102.2a3.07 3.07 0 0 0-1.07 1.13l-4.74-2.73a3.07 3.07 0 0 1 1.07-1.13l177-102.2a3.31 3.31 0 0 1 3 0l1.71 1A3.37 3.37 0 0 1 283 56Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "190.865px 105.7px"
    },
    className: "animable",
    id: "elx9rna0a0rdh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27 157.72v19.12l4.73 2.74v-19.13a3.21 3.21 0 0 1 .45-1.5l-4.74-2.73a3 3 0 0 0-.44 1.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "100.86px 167.9px"
    },
    id: "el57utozv0gi9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Forms--inject-149",
    className: "animable",
    style: {
      transformOrigin: "191.63px 258.895px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "260.685px 99.76px"
    },
    id: "el9e7phhuogx7",
    className: "animable",
    d: "m248.5 104.97 24.37-14.07v3.65l-24.37 14.07v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "256.135px 109.665px"
    },
    id: "elf8r04s13a6t",
    className: "animable",
    d: "m239.4 117.48 33.47-19.28v3.65l-33.47 19.28v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "260.82px 114.285px"
    },
    id: "elf9xx48lxsg9",
    className: "animable",
    d: "m248.77 119.41 24.1-13.9v3.65l-24.1 13.9v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "129.345px 175.59px"
    },
    id: "ell1930hzk9xo",
    className: "animable",
    d: "m110.39 184.71 37.91-21.89v3.65l-37.91 21.89v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "138.825px 177.42px"
    },
    id: "ela175q1iy5y",
    className: "animable",
    d: "m110.39 192.01 56.87-32.83v3.64l-56.87 32.84v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "135.665px 186.535px"
    },
    id: "elo6dsk3oax6",
    className: "animable",
    d: "m110.39 199.3 50.55-29.18v3.65l-50.55 29.18v-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 170.645px"
    },
    id: "el6lurmpe9blf",
    className: "animable",
    d: "m110.39 212.85 162.48-93.8v9.38l-162.48 93.81v-9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "191.63px 170.645px"
    },
    className: "animable",
    d: "m110.39 212.85 162.48-93.8v9.38l-162.48 93.81v-9.39z",
    id: "elkfs6xigps5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 130.16v35.21L111.39 258v-35.19l160.48-92.65m1-1.73-162.48 93.81v37.52L272.87 166v-37.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 194.095px"
    },
    id: "elmi43la718hr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.64px 194.09px",
      transform: "rotate(-29.99deg)"
    },
    className: "animable",
    d: "M98.37 193.59h186.54v1H98.37z",
    id: "elbgyu4ecgkr"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "195.69px 200.845px"
    },
    id: "elc2mwuk29zq8",
    className: "animable",
    d: "M195.19 191.75h1v18.19h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 226.925px"
    },
    id: "elh5gfrj0acxc",
    className: "animable",
    d: "m110.39 269.14 162.48-93.81v9.38l-162.48 93.81v-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "191.63px 226.925px"
    },
    className: "animable",
    d: "m110.39 269.14 162.48-93.81v9.38l-162.48 93.81v-9.38z",
    id: "el2t2n6hiyrfr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 186.44v35.22l-160.48 92.65V279.1l160.48-92.66m1-1.73-162.48 93.81V316l162.48-93.81v-37.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 250.355px"
    },
    id: "elx2rw38xoqep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.64px 250.38px",
      transform: "rotate(-30.02deg)"
    },
    className: "animable",
    d: "M98.37 249.88h186.54v1H98.37z",
    id: "eldjkf7kcbsov"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "163.64px 276.155px"
    },
    id: "ellnskgk6ux2f",
    className: "animable",
    d: "M163.14 267.01h1v18.29h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "237.85px 214.595px"
    },
    id: "ellmo5olm923g",
    className: "animable",
    d: "M237.35 205.5h1v18.19h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 283.215px"
    },
    id: "el1czdlvf3edq",
    className: "animable",
    d: "m110.39 325.43 162.48-93.81V241l-162.48 93.81v-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "191.63px 283.215px"
    },
    className: "animable",
    d: "m110.39 325.43 162.48-93.81V241l-162.48 93.81v-9.38z",
    id: "elbj3awhu5hbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 242.73v16.45l-160.48 92.66v-16.46l160.48-92.65m1-1.73-162.48 93.81v18.76l162.48-93.81V241Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 297.285px"
    },
    id: "elw33y04sx55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "164.44px 313.055px"
    },
    id: "el06mvfuiber27",
    className: "animable",
    d: "M163.94 304.32h1v17.47h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "218.02px 282.075px"
    },
    id: "elkieygcgbty",
    className: "animable",
    d: "M217.52 273.29h1v17.57h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 311.355px"
    },
    id: "elpodpmg2cu",
    className: "animable",
    d: "m110.39 353.57 162.48-93.81v9.38l-162.48 93.81v-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "191.63px 311.355px"
    },
    className: "animable",
    d: "m110.39 353.57 162.48-93.81v9.38l-162.48 93.81v-9.38z",
    id: "el3vlfhxbjvfq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 270.87v16.46L111.39 380v-16.47l160.48-92.66m1-1.73L110.39 363v18.76l162.48-93.86v-18.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 325.45px"
    },
    id: "elypqogc422fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "164.44px 341.195px"
    },
    id: "elepmyhoe7yal",
    className: "animable",
    d: "M163.94 332.46h1v17.47h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "218.02px 310.215px"
    },
    id: "el5asyg8h78a",
    className: "animable",
    d: "M217.52 301.43h1V319h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 339.495px"
    },
    id: "el3ezg8j69ij3",
    className: "animable",
    d: "m110.39 381.71 162.48-93.81v9.38l-162.48 93.81v-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "191.63px 339.495px"
    },
    className: "animable",
    d: "m110.39 381.71 162.48-93.81v9.38l-162.48 93.81v-9.38z",
    id: "elwcrkxyvbz8k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 299v16.45l-160.48 92.67v-16.45L271.87 299m1-1.74-162.48 93.83v18.76l162.48-93.8v-18.77Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "191.63px 353.555px"
    },
    id: "elyeop8bpkik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "164.44px 369.335px"
    },
    id: "el38j3jgecacc",
    className: "animable",
    d: "M163.94 360.6h1v17.47h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "218.02px 338.355px"
    },
    id: "eltvpln2x5ac",
    className: "animable",
    d: "M217.52 329.57h1v17.57h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87 316.64v16.45l-53.35 30.79v-16.46l53.35-30.78m1-1.73-55.35 31.93v18.77l55.35-31.94v-18.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "245.195px 340.26px"
    },
    id: "elgfcmqkbgsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "151.43px 399.245px"
    },
    id: "elx87je5uf6iq",
    className: "animable",
    d: "m110.39 418.99 82.08-47.39v7.9l-82.08 47.39v-7.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130.63 218.78a2.9 2.9 0 0 0 .2-2.47 1.63 1.63 0 0 0-2.21-.48 11.08 11.08 0 0 0-4.7 4.76 12.54 12.54 0 0 0-1.59 6.19c0 .75.21 1.52 1 1.72a2.65 2.65 0 0 0 2.26-.8c1.87-1.65 2.57-4.19 3.18-6.52.07-.25-.35-.68-.46-.34a13 13 0 0 0-.84 4 .9.9 0 0 0 1.39.88 5.82 5.82 0 0 0 1.85-2.09 7.49 7.49 0 0 0 1-2.39c.1-.51.09-1.18-.44-1.46s-1 .45-1.16.94a3.26 3.26 0 0 0-.09 2.3 1.83 1.83 0 0 0 2.09 1.18c1.19-.3 2-1.65 2.49-2.66a10.06 10.06 0 0 0 1.07-4c0-.22-.29-.59-.46-.29a4.7 4.7 0 0 0-.66 3.1c.18.74.82 1.19 1.53.74a6.42 6.42 0 0 0 1.9-2.44 8.39 8.39 0 0 0 .85-3.36c0-.15-.22-.57-.4-.34a4.81 4.81 0 0 0-.84 2.17 2.7 2.7 0 0 0 .16 1.94c.44.59 1.11.06 1.51-.31a6 6 0 0 0 1.56-3.09h-.4a8.36 8.36 0 0 1 .87 2.47c0 .19.4.4.42.1a7.53 7.53 0 0 1 .73-2.71 8.94 8.94 0 0 1 .76-1.31c.15-.2.44-.69.68-.76s.2.08.25.31a7.34 7.34 0 0 1 .09.82c0 .52 0 1 .07 1.55 0 .2.38.52.44.17a10 10 0 0 1 2.22-4.5 3.47 3.47 0 0 1 1.24-1.11c.11 0 .05 0 0-.1a.55.55 0 0 1 0 .22l-.06.33c-.06.26-.14.51-.19.77a1.77 1.77 0 0 0 .35 1.44c.52.56 1.1.13 1.52-.31a12.93 12.93 0 0 0 3.1-4.82 1.72 1.72 0 0 0-.11-1.5.78.78 0 0 0-1.28.07 4.71 4.71 0 0 0-.76 2.51 3.09 3.09 0 0 0 .41 1.81 1.55 1.55 0 0 0 1.23.86c.77 0 1.29-.73 1.69-1.29a48.86 48.86 0 0 0 2.54-4.46 12.35 12.35 0 0 1 .74-1.14c.14-.18.45-.69.69-.73s.24.73.25 1c0 1.32-.17 2.63-.2 3.94 0 .18.35.62.44.29a23 23 0 0 1 1.23-3.3 10.54 10.54 0 0 1 1.7-2.8c.11-.13.59-.67.8-.55s.11.81.11 1c0 .84-.19 1.67-.21 2.52 0 .24.34.6.44.23a14.34 14.34 0 0 1 2.28-5.39 2.67 2.67 0 0 1 1-.84c.14-.06.54-.24.7-.13s.19.62.17.88a1.2 1.2 0 0 0 .76 1.3 1.81 1.81 0 0 0 1.86-.64 10.59 10.59 0 0 0 1.79-2.31c.51-.86 1.51-2.71.14-3.36a.18.18 0 0 0-.22 0 6.92 6.92 0 0 0-1.19 2.82c-.12.7-.32 1.84.4 2.3s1.45 0 2-.44a6.14 6.14 0 0 0 1.82-2.34c.11-.24-.29-.65-.44-.35a6.28 6.28 0 0 1-1.2 1.68c-.38.39-1 1-1.63 1-.86 0-.49-1.57-.34-2.12a6.26 6.26 0 0 1 1-2.12h-.22c1.24.59-1.61 4-2.12 4.57a2.2 2.2 0 0 1-1.09.73 1 1 0 0 1-.42 0l-.43-.58c0-.15.08-.41.08-.57a1 1 0 0 0-.61-1c-1.23-.44-2.29 1.2-2.78 2.05a18.11 18.11 0 0 0-1.68 4.58l.44.23c0-.6.84-4.91-.79-4.21-.95.41-1.58 1.72-2 2.58a21.76 21.76 0 0 0-1.67 4.2l.44.29c0-1 .15-2 .19-3.07a4.08 4.08 0 0 0-.29-2.4c-1-1.33-3.4 4-3.71 4.54-.48.88-2.32 4.29-3.33 2.16a3.83 3.83 0 0 1 .12-2.86 2.83 2.83 0 0 1 .28-.58c.05-.06.19-.28.29-.29s.43.26.46.34c.13.35-.23 1-.37 1.27a13.55 13.55 0 0 1-1.43 2.44c-.25.35-.52.68-.8 1s-.84 1.12-1.31 1c-.23 0-.31-.49-.31-.68a2.33 2.33 0 0 1 0-.38c0-.24.12-.47.17-.7a1.25 1.25 0 0 0-.06-1c-.64-.75-1.94 1.1-2.23 1.5a10.12 10.12 0 0 0-2 4.27l.43.17c-.08-.72 0-1.45-.13-2.17 0-.39-.15-1.15-.66-1.21s-1.26 1.15-1.52 1.59a8.29 8.29 0 0 0-1.14 3.55l.42.1a8.8 8.8 0 0 0-.92-2.62c-.09-.16-.33-.27-.39 0a6.53 6.53 0 0 1-1.1 2.5c-.22.26-1.05 1.21-1.3.68a2.91 2.91 0 0 1 .11-1.57 4 4 0 0 1 .68-1.63l-.4-.34a7.88 7.88 0 0 1-1.48 4.31 8.2 8.2 0 0 1-.71.85c-.14.14-.35.42-.55.44a.57.57 0 0 1-.66-.49 4.51 4.51 0 0 1 .67-2.57l-.45-.29a8.79 8.79 0 0 1-2.42 5.82 1.71 1.71 0 0 1-1.51.54 1.4 1.4 0 0 1-.94-1.47c0-.46.18-1.64.65-1.86s.08 1.26 0 1.48a9.4 9.4 0 0 1-1.27 2.19 6.07 6.07 0 0 1-.7.82 1.93 1.93 0 0 1-.57.41c-.52.22-.51-.17-.48-.55a16.29 16.29 0 0 1 .78-3.52l-.46-.34a17.74 17.74 0 0 1-1.79 4.79 6.36 6.36 0 0 1-1.64 1.86c-.66.47-1.92.86-2.08-.28a8.17 8.17 0 0 1 .21-2.56 11.5 11.5 0 0 1 .79-2.56 12.56 12.56 0 0 1 2.93-4.17 7 7 0 0 1 2.39-1.65c.67-.23 1.44-.06 1.55.73a3.62 3.62 0 0 1-.29 1.59c0 .13.14.38.22.19Z",
    style: {
      fill: "#455a64",
      transformOrigin: "148.239px 212.337px"
    },
    id: "elw881897dlir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41 189.74a4.94 4.94 0 0 1 .85-4.65 5.5 5.5 0 0 1 1.42-1.54c.47-.32 1.06-.5 1.34.13a2.36 2.36 0 0 1 0 1.21c-.18 1.39-.62 2.74-.83 4.12a24.72 24.72 0 0 1-.86 4.19l.38.25a9.27 9.27 0 0 1 1.56-4 3.32 3.32 0 0 1 .72-.9c.41-.23.39.05.38.38s0 .39 0 .59c0 .86-.11 1.72-.21 2.58 0 .2.33.47.37.19a7.48 7.48 0 0 1 .48-1.8c.23-.54.5-1.21 1.11-1.4l-.22-.18a3.37 3.37 0 0 1 .19 1.41c0 .15.24.46.31.2a3.76 3.76 0 0 1 1.16-2.19l-.24-.21c0 .48-.13 1.49.37 1.82s1.31-.55 1.62-.94a14.59 14.59 0 0 0 1.51-2.47 6.45 6.45 0 0 0 .85-2.58c0-.14-.12-.35-.29-.3-.61.17-1 1.08-1.21 1.61a6.71 6.71 0 0 0-.52 2.25c-.11 1.71.25 3.46-.42 5.09-.06.17.21.52.31.29a9.47 9.47 0 0 0 .47-4.17 8.19 8.19 0 0 1 .22-2.37c.17-.61.65-2 1.34-2.22l-.29-.31a8.78 8.78 0 0 1-1.5 3.68 8.12 8.12 0 0 1-1.09 1.52c-.1.1-.2.2-.31.29a.4.4 0 0 1-.69-.19 3.4 3.4 0 0 1-.06-1c0-.1-.12-.31-.24-.21a3.9 3.9 0 0 0-1.28 2.32l.3.2a4 4 0 0 0-.21-1.65c0-.09-.11-.21-.22-.18-1.21.35-1.66 2.34-1.82 3.4l.37.19a21.84 21.84 0 0 0 .23-3.52c0-.55-.37-1.15-.95-.65a7.3 7.3 0 0 0-1.61 2.34 9.29 9.29 0 0 0-.85 2.82c0 .21.27.57.38.25.66-2 .73-4.16 1.19-6.23.25-1.11 1.12-3.29.05-4.25s-2.76 1.35-3.25 2.14a5.06 5.06 0 0 0-.57 4.78c.11.25.33.05.24-.15Z",
    style: {
      fill: "#455a64",
      transformOrigin: "188.232px 188.139px"
    },
    id: "elwjt2umg7bic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 186.57c2-.41 3.29-2.22 4.28-3.88a10.41 10.41 0 0 0 1.34-2.89c.09-.5-.2-1-.77-.83a2.93 2.93 0 0 0-1.38 1.8 6.43 6.43 0 0 0-.3 2.54 1.7 1.7 0 0 0 .94 1.59c.81.29 1.64-.32 2.19-.86a9 9 0 0 0 2.51-5.69c0-.21-.35-.49-.4-.18a9.91 9.91 0 0 0 0 3.35c0 .14.26.39.36.18a7 7 0 0 1 2-3l-.31-.21c.18.73.34 1.47.47 2.21 0 .16.3.39.36.12a9.45 9.45 0 0 1 1.14-2.82c.16-.27.79-1.42 1.18-1.06.08.08 0 .52.05.62l.08 1c0 .18.28.36.36.12a13.45 13.45 0 0 1 2.82-5.33 1.48 1.48 0 0 1 .51-.42c.42-.13.26.48.22.71a14.2 14.2 0 0 0-.26 1.45 1 1 0 0 0 .79 1.19c.78.08 1.25-.76 1.6-1.31a14 14 0 0 0 2.24-8.27c0-.17-.19-.38-.38-.3-.51.2-.63.77-.78 1.26-.19.65-.34 1.31-.47 2a10.91 10.91 0 0 0-.24 4c.18.81.82 1.76 1.78 1.43a3.51 3.51 0 0 0 1.39-1.26 13.16 13.16 0 0 0 1.22-1.91c.12-.21-.22-.62-.38-.35a12.41 12.41 0 0 1-1.78 2.47c-.39.39-1 .84-1.5.27a2.63 2.63 0 0 1-.33-1.7 18.3 18.3 0 0 1 .33-2.85c.1-.51.22-1 .35-1.52s.23-1.12.69-1.31l-.37-.31a13.74 13.74 0 0 1-1.07 5.9 12.09 12.09 0 0 1-1.48 2.68 1.41 1.41 0 0 1-.49.45c-.3.18-.53 0-.69-.38 0-.17 0-.34.07-.51.07-.47.17-.94.25-1.42s0-1-.52-1-1.2.83-1.54 1.26a16 16 0 0 0-2.3 4.81l.37.12c0-.47 0-1-.12-1.43a1 1 0 0 0-.17-.52c-.31-.38-.75-.16-1 .13a8.39 8.39 0 0 0-1.85 3.88l.36.12c-.13-.74-.29-1.47-.47-2.2 0-.13-.16-.33-.31-.22a7.29 7.29 0 0 0-2.12 3l.36.17a9.55 9.55 0 0 1 0-3.11l-.4-.18a8.44 8.44 0 0 1-2.05 5c-.5.58-1.7 1.8-2.5 1-.59-.57-.32-2.09-.15-2.79a4.17 4.17 0 0 1 .45-1.14c.07-.12 1-1.32 1.08-.63a3.22 3.22 0 0 1-.34.86c-.09.2-.18.41-.28.61-.19.4-.4.8-.62 1.19-.92 1.63-2.14 3.41-4 4-.09 0-.09.25 0 .22Z",
    style: {
      fill: "#455a64",
      transformOrigin: "207.259px 176.476px"
    },
    id: "elt1y5gaugro9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4 238.17c-.09-1-1.24-.93-1.92-.53a9.37 9.37 0 0 0-2.58 2.28 9.52 9.52 0 0 0-2.13 6.24c.06.77.41 1.77 1.32 1.81a2.4 2.4 0 0 0 1.42-.61c.51-.35 1-.71 1.49-1.08a13.74 13.74 0 0 0 4.69-6.1 7.7 7.7 0 0 0 .48-3.42c-.14-1-1-1.17-1.68-.57a8.43 8.43 0 0 0-2.69 6.36 1.82 1.82 0 0 0 1.38 2 3.4 3.4 0 0 0 2.83-1.17 11.7 11.7 0 0 0 2.32-2.87c.32-.58 1.25-1.93.59-2.56s-1.68.66-1.82 1.3-.19 2.06.69 2.43c1.21.51 2.21-1 2.7-1.87a7.73 7.73 0 0 0 1-3.9c0-.17-.22-.35-.31-.14a4.68 4.68 0 0 0 .26 4.43c.06.09.21.11.24 0a13.28 13.28 0 0 1 1.6-3.71c.15-.24.31-.48.48-.71s.44-.76.8-.67.26.54.29.85l.06.47c0 .39.09.79.13 1.18 0 .12.22.38.28.15a10.25 10.25 0 0 1 1.31-3.21 3.86 3.86 0 0 1 .55-.65 2.34 2.34 0 0 1 .35-.29c.26-.18.32-.24.61-.07s.27.31.31.62l.06.5.15 1.24a.28.28 0 0 0 .21.25c.94 0 1.48-.78 1.91-1.49a24.38 24.38 0 0 0 1.78-3.49 12.74 12.74 0 0 0 1-6.94c0-.13-.25-.38-.35-.17a20.73 20.73 0 0 0-1.68 5 19.68 19.68 0 0 0-.33 2.53 2.07 2.07 0 0 0 .34 1.63c1 1.07 2.41-.61 3-1.34a19.06 19.06 0 0 0 2.27-4.45l-.34-.3a7.74 7.74 0 0 0 0 4.76c0 .09.23.3.31.11a22.31 22.31 0 0 1 2.62-4.41c.3-.38.6-.76.92-1.12s.65-.88 1-.94c.51-.09.53.78.59 1.14a9.5 9.5 0 0 1 .12 1.6c0 .18.32.49.39.18a13.5 13.5 0 0 1 4-6.93l-.27-.09c.59 1.09-.33 2.58.7 3.54s2-.3 2.48-1.11c.11-.2-.19-.6-.33-.35a2.61 2.61 0 0 1-1.19 1.22c-.68.23-1.07-.37-1.14-1-.1-.9.21-1.72-.25-2.58 0-.09-.18-.17-.27-.09a13.76 13.76 0 0 0-4.09 7.12l.39.18a11 11 0 0 0-.12-1.62 4 4 0 0 0-.37-1.44c-.51-.85-1.35.11-1.74.55a22.75 22.75 0 0 0-3.72 5.78l.31.12a7.19 7.19 0 0 1 0-4.4c0-.16-.24-.55-.34-.3a26.79 26.79 0 0 1-1.55 3.35 9.62 9.62 0 0 1-1.15 1.61 4.64 4.64 0 0 1-.72.68 2.05 2.05 0 0 1-.46.25c-.36.13-.45.1-.73-.17s-.3-.62-.27-1.08.07-.73.11-1.1c.09-.7.22-1.4.38-2.09a20.76 20.76 0 0 1 1.47-4.11l-.36-.17a12.24 12.24 0 0 1-.94 6.59 24.65 24.65 0 0 1-1.4 2.82c-.43.75-1 2-2 2l.22.24c-.14-1-.13-4-1.82-2.58-1.26 1-1.73 2.68-2.14 4.18l.28.15c-.07-.55-.13-1.1-.2-1.65a4.06 4.06 0 0 0-.15-1.1c-.23-.51-.7-.39-1 0a12.15 12.15 0 0 0-2.56 5.09h.24a4.06 4.06 0 0 1-.16-3.91l-.32-.14A6.51 6.51 0 0 1 133 241c-.55.41-1.33.5-1.58-.32a2.77 2.77 0 0 1 0-1.18 1.72 1.72 0 0 1 .52-1c.1-.1.41-.33.57-.26.41.18.06.65 0 .89a11.15 11.15 0 0 1-3.08 4 2.67 2.67 0 0 1-2.4.81c-1.14-.36-.86-1.91-.69-2.82a8.18 8.18 0 0 1 2.33-4.42c.14-.13.34-.35.55-.37.64-.07.57.35.58.71a8.16 8.16 0 0 1-.12 1.39 10.09 10.09 0 0 1-.92 2.71 13.49 13.49 0 0 1-3.26 4 24.3 24.3 0 0 1-2.12 1.63 3.71 3.71 0 0 1-1 .6c-.79.21-1.08-.48-1.13-1.13a8.78 8.78 0 0 1 1.42-5 9.7 9.7 0 0 1 1.75-2.13c.43-.4 2.58-2.21 2.83-.9 0 .18.22.1.2-.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "142.06px 234.499px"
    },
    id: "elyl2bincf46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.28 190.35a.72.72 0 0 0-.15-1c-.52-.45-1.14 0-1.54.36a17.21 17.21 0 0 0-3.47 4.7c-.6 1.3-1.28 3.5-.18 4.73a1.85 1.85 0 0 0 1.95.45 4.46 4.46 0 0 0 2.06-1.83c1.34-1.83 2.63-3.79 2.84-6.1 0-.24-.37-.57-.4-.24a21.81 21.81 0 0 0 0 4.71c0 .16.25.49.39.24a32.93 32.93 0 0 0 2.28-5.2l-.4-.24.11 2a3.29 3.29 0 0 0 .18 1.21c.27.59.87.74 1.26.18a9.3 9.3 0 0 0 1-2.56 6.5 6.5 0 0 1 1.53-2.78l-.32-.14a9.36 9.36 0 0 1 .49 3.57c0 .21.36.48.39.18a16.59 16.59 0 0 1 1.32-5l-.37-.24v1.82a2.69 2.69 0 0 0 .09 1c.32.78.94.33 1.34-.1A8.86 8.86 0 0 0 222 185c0-.17-.13-.48-.34-.34a2 2 0 0 0-.92 2c.1.54.54 1.16 1.16 1 .78-.2 1.39-1.48 1.74-2.12a10.94 10.94 0 0 0 1.09-3c.05-.24-.32-.57-.4-.25a32.31 32.31 0 0 0-.83 4.88c-.08 1 .3 2 1.48 1.89s1.92-1.83 2.47-2.79q1.29-2.29 2.43-4.67l-.38-.17c.24 1.3.49 2.59.73 3.89 0 .17.35.4.39.11a8.29 8.29 0 0 1 2.78-5.06l-.31-.15a8.39 8.39 0 0 1 .72 2.68c0 .17.34.39.38.12a9.57 9.57 0 0 1 2.84-5.71l-.26-.09c.47 1-.38 2.36.61 3.14s2.27-.49 2.9-1.22a12.93 12.93 0 0 0 2.3-3.75c.29-.76.4-1.81-.44-2.25a.15.15 0 0 0-.2 0 4.08 4.08 0 0 0-1 4.91 1.43 1.43 0 0 0 1.84.79 6.68 6.68 0 0 0 2.24-2.42c.14-.2-.18-.6-.36-.35a10.47 10.47 0 0 1-1.55 1.77c-.35.31-.8.73-1.3.5a1.67 1.67 0 0 1-.75-1.14 3.67 3.67 0 0 1 1.25-3.62h-.21c.88.47-.29 2.36-.6 2.91a13.84 13.84 0 0 1-1.9 2.51 3.18 3.18 0 0 1-1.24.94c-.74.24-1.12-.27-1.12-1a4.43 4.43 0 0 0-.2-2.08c0-.09-.18-.17-.26-.09a9.88 9.88 0 0 0-3 5.89l.38.12a9.2 9.2 0 0 0-.75-2.82c-.05-.11-.19-.25-.31-.15a8.64 8.64 0 0 0-2.9 5.26l.39.12-.72-3.9c0-.14-.28-.38-.39-.16a72.84 72.84 0 0 1-1.74 3.41c-.3.56-.61 1.12-.93 1.67a8.16 8.16 0 0 1-1.11 1.72c-.39.39-1.14.78-1.64.31s-.12-1.63-.05-2.16a34.24 34.24 0 0 1 .69-3.66l-.4-.25a10.22 10.22 0 0 1-1.42 3.58c-.3.47-1 1.76-1.66 1.14-.27-.24-.11-.86 0-1.13a2 2 0 0 1 .68-.75l-.34-.34a8.58 8.58 0 0 1-1.36 3.81 7.65 7.65 0 0 1-.69.9c-.21.24-.67.73-.88.35s0-.86 0-1.13v-1.25c0-.15-.26-.49-.37-.24a17 17 0 0 0-1.37 5.09l.4.19a10 10 0 0 0-.54-3.84c0-.12-.21-.25-.33-.15a8.3 8.3 0 0 0-1.83 3.59c-.13.39-.26.78-.42 1.15s-.45 1.23-.9.71c-.21-.25-.12-1-.14-1.31l-.08-1.6c0-.14-.3-.51-.39-.23a33.34 33.34 0 0 1-2.28 5.2l.39.23a21.35 21.35 0 0 1 0-4.59l-.41-.18a10.68 10.68 0 0 1-2.19 5.1 9.63 9.63 0 0 1-1.72 2.09c-.84.67-2.32.8-2.61-.5-.39-1.7.6-3.62 1.52-5a25.06 25.06 0 0 1 1.61-2.08c.26-.3.52-.61.79-.9a2 2 0 0 1 .51-.44.76.76 0 0 1 .29-.13c.35-.08.56.11.61.58-.05.08 0 .29.09.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "224.205px 186.4px"
    },
    id: "el7mm7845i6fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 277.69a10.4 10.4 0 0 0 7.66-4.79c.27-.43.65-.94.49-1.48-.3-1.09-1.58-1-2.31-.43a12.84 12.84 0 0 0-4.32 6.63c-.26.93-.63 2.16-.1 3.07.61 1.07 1.83.67 2.57 0a21.58 21.58 0 0 0 2.65-3.69c.33-.48.95-1.52 1.56-1.65.94-.2.75 2.4.74 3 0 .2.34.49.4.18a9.23 9.23 0 0 1 .89-2.75 3.7 3.7 0 0 1 .31-.55c.13-.34.39-.34.79 0v.31a1.58 1.58 0 0 0 .27.88c.11.16.33.17.33-.06a3.93 3.93 0 0 1 1.78-3.19l-.31-.21c.15.55.29 1.11.44 1.67 0 .16.26.26.33.06a11.85 11.85 0 0 1 1.17-2.4h-.25c.35.39.13 1.11.67 1.37s1.39-.74 1.75-1.16a15.14 15.14 0 0 0 2.8-4.48c.49-1.31-1.15-1.88-1.68-.65a6.28 6.28 0 0 0-.23 2.4c0 .6 0 1.4.48 1.83s1.32 0 1.79-.44a6.11 6.11 0 0 0 1.75-2.5c.08-.21-.25-.63-.37-.35a6.73 6.73 0 0 1-1.12 1.85 6 6 0 0 1-.72.7c-.15.11-.45.39-.65.39a1 1 0 0 1-.72-.54 7.07 7.07 0 0 1 0-2.25 1.69 1.69 0 0 1 .37-1.13c.09-.08.4-.27.55-.19l.26.54a3.79 3.79 0 0 1-.18.42 16.17 16.17 0 0 1-2.17 3.55c-.25.31-.51.61-.78.91s-.59.76-1 .59-.25-.39-.34-.68a1.22 1.22 0 0 0-.27-.5c-.07-.08-.18-.11-.25 0a12.27 12.27 0 0 0-1.21 2.5l.33.06-.39-1.54c0-.14-.15-.32-.31-.22a4.28 4.28 0 0 0-1.91 3.48l.33-.06c-.35-.5-.07-1.17-.53-1.64a.6.6 0 0 0-.95 0 5.87 5.87 0 0 0-.9 1.67 10.63 10.63 0 0 0-.59 2.09l.4.18a14.87 14.87 0 0 0-.08-2 3 3 0 0 0-.31-1.32c-.52-.78-1.33-.18-1.8.31a18.85 18.85 0 0 0-2 2.85c-.56.86-1.49 2.46-2.65 2.53-1.45.08-.58-2.53-.37-3.21a13.31 13.31 0 0 1 1.65-3.39 10.72 10.72 0 0 1 2.4-2.67 1.68 1.68 0 0 1 .87-.39c.85 0 .53.82.28 1.24a11.14 11.14 0 0 1-1 1.36 11.5 11.5 0 0 1-6.38 3.57c-.18 0-.1.4.08.39Z",
    style: {
      fill: "#455a64",
      transformOrigin: "136.38px 274.02px"
    },
    id: "el1zoh4y21vmy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6 265.79a8.11 8.11 0 0 1 1-1.21c.38-.38 1.2-1.26 1.53-.39a5.54 5.54 0 0 1 .12 1.95A11.54 11.54 0 0 1 153 268l.48.22a5.58 5.58 0 0 1 2.34-4.06l-.28-.09a2 2 0 0 1 .4 1.58l.45.23a4.08 4.08 0 0 1 .28-1.29 1.8 1.8 0 0 1 .28-.53c.2-.23.62-.45.62 0 0 .13.23.49.34.24.26-.56.51-1.13.76-1.69l-.3-.3a.94.94 0 0 0 .82 1.25c.93.05 1.6-1.25 2-1.89a6.15 6.15 0 0 0 1.22-2.82 1.24 1.24 0 0 0-.84-1.44c-.07 0-.11.06-.13.11a6.43 6.43 0 0 0-.35 4.54c.17.4.53.87 1 .76s1-1 1.27-1.44c1.92-2.78 3.72-5.89 3.42-9.39 0-.18-.27-.36-.36-.13a18.66 18.66 0 0 0-1.11 5.16 13.24 13.24 0 0 0 0 2.27 1.61 1.61 0 0 0 .64 1.27.15.15 0 0 0 .21 0c.72-1.21 1.4-2.45 2.05-3.7l-.35-.18a6.21 6.21 0 0 0 .47 1.75c.06.15.27.27.34.06a9.75 9.75 0 0 1 .92-1.86l-.28-.05a6.05 6.05 0 0 1 .49 1.37c0 .2.32.39.36.08a7 7 0 0 1 2.06-4.14l-.25-.37a1.56 1.56 0 0 0 .88 2.14c1.19.36 2-1 2.46-1.88.07-.14-.15-.49-.26-.29a4.2 4.2 0 0 1-1.29 1.57c-.8.47-2-.19-1.51-1.2.06-.13-.07-.55-.25-.37a7.42 7.42 0 0 0-2.2 4.4l.36.08a7.37 7.37 0 0 0-.58-1.63c-.06-.11-.21-.17-.29-.05a10.17 10.17 0 0 0-1 2l.35.07a6.16 6.16 0 0 1-.43-1.62c0-.14-.24-.38-.35-.18a145.7 145.7 0 0 1-2 3.71h.21c-.56-.35-.43-1.38-.43-1.95a16.86 16.86 0 0 1 1.15-6.08l-.35-.13a10.76 10.76 0 0 1-1.24 5.52 23.64 23.64 0 0 1-2.83 4.54c-.52.63-1 .05-1.11-.54a5.94 5.94 0 0 1 0-1.46 6.72 6.72 0 0 1 .28-1.55 2.81 2.81 0 0 1 .1-.31c0-.22.08-.27.22-.14s.27.5.25.74a5.92 5.92 0 0 1-1.14 2.56c-.24.35-.48.72-.75 1.05a2 2 0 0 1-.64.59c-.22.11-1.15.19-.9-.37.09-.19-.17-.58-.28-.34-.27.56-.53 1.12-.79 1.69l.34.24c0-.44-.2-1.39-.84-1.08a2.13 2.13 0 0 0-.74 1 4.6 4.6 0 0 0-.42 1.5c0 .26.4.59.45.23a2.78 2.78 0 0 0-.57-2.15c-.05-.07-.19-.15-.28-.09A6 6 0 0 0 153 268c0 .27.41.6.48.22a10.52 10.52 0 0 0 .21-2.85c0-.57 0-1.49-.46-1.92-1-1-2.53 1.3-2.93 2-.1.18.15.57.31.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "162.8px 260.072px"
    },
    id: "elt1xzofx4o3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 242.62c-1.8 1-2 3.62-2.58 5.35a16.51 16.51 0 0 1-1.68 3.46 5.8 5.8 0 0 1-2.54 2.46l.36.23c-.29-1.2 1.65-2 2.48-2.42a17.9 17.9 0 0 1 3.5-1.14c.2 0 .08-.48-.11-.46a11.61 11.61 0 0 0-4.32 1.4c-1 .54-2.31 1.35-2 2.68 0 .15.2.3.36.23a5.42 5.42 0 0 0 2.34-2.11 17.3 17.3 0 0 0 1.73-3.23c.83-2 .88-4.55 2.6-6.12.1-.09 0-.41-.16-.33Z",
    style: {
      fill: "#455a64",
      transformOrigin: "180.622px 248.517px"
    },
    id: "elqdeanngj2wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08 247.2c.32-1.61 2.06-2.13 3.48-2.31.81-.1 2.07-.22 2 1a2.93 2.93 0 0 1-1.27 1.75l.3.43a6.54 6.54 0 0 1 1.94-1.48 1.89 1.89 0 0 1 .46-.2c.15-.12.28-.09.38.1a.34.34 0 0 1 .23.4 5.29 5.29 0 0 1 0 1.59c0 .25.4.58.43.24a3.18 3.18 0 0 1 1.55-2.52l-.27-.1.54.83c.09.15.31.16.35 0a2.59 2.59 0 0 1 .54-1.3c.25-.25 1-.5 1.17 0 0 .15.33.41.39.11a3.75 3.75 0 0 1 1-1.88h-.23c1.15 1.2 3.06-1.14 3.59-2a3 3 0 0 0 .41-2.24c-.13-.48-.52-1-1-.52a4.38 4.38 0 0 0-.61 2.54c0 .56 0 1.42.56 1.77s1.24-.34 1.6-.78a11.79 11.79 0 0 0 1.59-2.58 12.83 12.83 0 0 0 1.07-6.17c0-.17-.25-.36-.29-.1a24.88 24.88 0 0 0-.48 3.84 10.17 10.17 0 0 0 .13 1.91 1.65 1.65 0 0 0 .43 1c.66.57 1.39-.49 1.77-.92a12.29 12.29 0 0 0 1.81-2.76l-.45-.22a4 4 0 0 0 .42 1.59c.08.16.38.28.41 0a2.66 2.66 0 0 1 .28-1 2.34 2.34 0 0 1 .36-.51c.25-.26.33-.39.69-.2s.3.33.42.69a2.63 2.63 0 0 0 .24.51c.06.09.29.19.34 0a11.54 11.54 0 0 1 2.44-4.29l-.32-.14c.32.66.15 1.52.79 2s1.29-.17 1.74-.62a6.71 6.71 0 0 0 1.43-2.13 3.15 3.15 0 0 0 .35-2.14.79.79 0 0 0-.42-.46c-.31-.08-.48.19-.63.42a2.25 2.25 0 0 0-.24 1.89 2.08 2.08 0 0 0 3.29 1c.2-.16-.09-.62-.32-.44a1.58 1.58 0 0 1-2.31-2.16c.52-.41.07 1.12 0 1.3a6.67 6.67 0 0 1-1.53 2.38c-.47.47-1.24 1.08-1.51 0a6.37 6.37 0 0 0-.29-1.22c-.05-.1-.21-.27-.32-.14a11.66 11.66 0 0 0-2.54 4.37h.34c-.33-.52-.21-1.61-1-1.66-1-.07-1.6 1.43-1.68 2.21h.41a3.47 3.47 0 0 1-.33-1.3c0-.19-.31-.49-.44-.22a11.53 11.53 0 0 1-1.29 2.09 12.41 12.41 0 0 1-.82 1 2.16 2.16 0 0 1-.37.37c-.53.31-.6-.09-.67-.47a16.92 16.92 0 0 1 .21-5.54l-.3-.1a12.17 12.17 0 0 1-2.65 8.46 3.44 3.44 0 0 1-.53.6c-.34.24-.46.28-.75-.05a1.8 1.8 0 0 1-.3-1.36 3.94 3.94 0 0 1 .29-1.59.32.32 0 0 1 .36-.31c.32-.22.45-.11.41.34a2.24 2.24 0 0 1 0 .68 4.15 4.15 0 0 1-1.36 2.09c-.44.42-1.51 1.53-2.15.86-.05-.06-.16-.11-.23 0a4.15 4.15 0 0 0-1.08 2.06l.39.12a1.07 1.07 0 0 0-1.34-.74c-.79.2-1 1.12-1.18 1.81h.35l-.53-.84c-.05-.07-.18-.15-.27-.1a3.52 3.52 0 0 0-1.73 2.79l.43.24a8.53 8.53 0 0 0-.09-2.2c-.07-.35-.21-.74-.63-.78a3.08 3.08 0 0 0-1.58.64 6.54 6.54 0 0 0-1.47 1.26c-.16.17.09.62.3.43a3.05 3.05 0 0 0 1.36-2.18 1.46 1.46 0 0 0-1.17-1.52 6.12 6.12 0 0 0-3.23.59 2.89 2.89 0 0 0-1.66 2.14c0 .15.19.32.23.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.423px 239.391px"
    },
    id: "el72v3spsyhmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.11 202.23c-1-.28-2.23.62-3 1.18a9 9 0 0 0-2.49 3.7 7.54 7.54 0 0 0-.8 4.44 1.81 1.81 0 0 0 2.44 1.47 4.86 4.86 0 0 0 1.64-1.32 17.86 17.86 0 0 0 1.6-1.88 7.43 7.43 0 0 0 1.61-4.17 1.41 1.41 0 0 0-.47-1.21 1.12 1.12 0 0 0-1.54.37 8.28 8.28 0 0 0-1.05 1.83 7.34 7.34 0 0 0-.71 2.42c-.08 1.19.82 3.26 2.37 2.73.66-.22 1.12-1.09 1.45-1.65a10.81 10.81 0 0 0 1.15-2.79c.06-.21-.33-.57-.42-.29-.2.63-.73 2.65.47 2.74.58 0 .92-.64 1.14-1.06a17.72 17.72 0 0 0 1-2.47l-.41-.23c0 .41-.32 2.53.69 2.28.42-.11.69-.9.85-1.23a10.65 10.65 0 0 0 .73-2.05l-.42-.24a2.85 2.85 0 0 0 0 1.89.76.76 0 0 0 1.09.17 5.68 5.68 0 0 0 2.16-3.18c.14-.45.37-1.1 0-1.5s-.71-.15-.9.25c-.42.89-.84 2.62 0 3.41 1 1 2.21-.88 2.68-1.58a11.06 11.06 0 0 0 1.76-4.06 3.47 3.47 0 0 0 0-1.57c-.1-.31-.4-1-.84-1s-.74 1.07-.87 1.4a8.42 8.42 0 0 0-.52 2.09c-.12 1.13-.17 2.88 1.31 3.08a3.16 3.16 0 0 0 3.05-2.31c.09-.24-.3-.65-.41-.35a3.21 3.21 0 0 1-2.07 2.07c-.73.18-1.36-.06-1.47-.87a6.51 6.51 0 0 1 0-1.59 7.21 7.21 0 0 1 .46-1.77c.14-.36.64-1.6.93-.72s-.23 2.33-.63 3.26a11.91 11.91 0 0 1-1.72 2.81c-.35.42-1.34 1.41-1.63.32a3.56 3.56 0 0 1 .21-1.88c.05-.14.2-.81.4-.32.08.18-.2.74-.26.91a6.88 6.88 0 0 1-.79 1.46 4.15 4.15 0 0 1-1.08 1.13c-.81.46-.54-.9-.46-1.32.05-.25-.34-.58-.42-.24a10.23 10.23 0 0 1-.91 2.34 2.35 2.35 0 0 1-.32.55c-.24.06-.22-.25-.23-.37a7.76 7.76 0 0 1 0-1.18c0-.16-.32-.49-.41-.23a16.45 16.45 0 0 1-1 2.37 4.88 4.88 0 0 1-.31.55 1 1 0 0 1-.23.28l-.57-.2c-.19-.25.16-1.25.25-1.5l-.42-.29a10.84 10.84 0 0 1-1.45 3.1c-.35.5-.75 1.19-1.47 1a1.67 1.67 0 0 1-1.13-1.59 7.1 7.1 0 0 1 1.16-3.57c.14-.23.28-.47.44-.69a1.52 1.52 0 0 1 .32-.35l.15-.1.66.35c.09.15-.05.74-.07.89a6.38 6.38 0 0 1-.22.86 9.15 9.15 0 0 1-1.69 2.89 8.74 8.74 0 0 1-2.45 2.4 1.12 1.12 0 0 1-1.64-.4 3 3 0 0 1-.15-1.58 10.17 10.17 0 0 1 1.13-3.55 7.68 7.68 0 0 1 2.1-2.89c.6-.44 1.71-1.36 2.51-1.2.3.06.23-.42 0-.49Z",
    style: {
      fill: "#455a64",
      transformOrigin: "255.317px 205.384px"
    },
    id: "el9xn3qjg728o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94 294.75a1.22 1.22 0 0 0-1.42-1.22c-1.16.16-2.25 1.31-3 2.15a10.9 10.9 0 0 0-2.71 6.76c0 1 .12 2.06 1.2 2.37a4.33 4.33 0 0 0 3-.68 8.14 8.14 0 0 0 4.1-5.38c.16-.78.15-1.87-.67-2.28-1.08-.55-2 .84-2.39 1.6a5.6 5.6 0 0 0-1 3.5 1.94 1.94 0 0 0 2 1.47c1.22-.06 2.19-1.08 3-1.89a12.19 12.19 0 0 0 2.31-3.08 6.65 6.65 0 0 0 .76-3.5c-.09-.86-.89-1.55-1.67-.86a4.15 4.15 0 0 0-.88 1.84 4.55 4.55 0 0 0-.23 2.13 2.36 2.36 0 0 0 2 2.05c1.38 0 2.41-1.5 3.07-2.51a12.9 12.9 0 0 0 1.75-4.07l-.47-.23c-.3 1.27-.52 2.7.41 3.77.12.14.31.15.37-.05a7.4 7.4 0 0 1 2.38-3.76l-.36-.13a5.71 5.71 0 0 1 .59 2.36c0 .22.41.5.44.17a4.73 4.73 0 0 1 1.68-3.23l-.35-.13a3.41 3.41 0 0 1 .38 1.47c0 .21.39.5.43.17a6.42 6.42 0 0 1 2.53-4.39L142 289c.44.74-.29 2.82 1.13 3 .54.06 1-.5 1.39-.84a10.52 10.52 0 0 0 1.41-1.65 11.38 11.38 0 0 0 1.9-7.85c0-.14-.2-.41-.38-.3a3.81 3.81 0 0 0-1.64 2.91c-.19 1.24-.4 3 .39 4.07 2.12 2.85 4.72-2.66 5.15-4.27.07-.27-.37-.69-.49-.34a4.2 4.2 0 0 0-.2 2c.06.41.19 1 .65 1.18s1-.61 1.26-1a9.9 9.9 0 0 0 1.12-2l-.47-.22a1.35 1.35 0 0 0 .6 1.05.55.55 0 0 0 .81-.31c.07-.26-.35-.67-.45-.35-.33.09-.49 0-.47-.31s-.34-.51-.47-.21a9.06 9.06 0 0 1-1.34 2.21c-.06.07-.24.38-.35.4-.4.06-.4-.41-.42-.63a3.7 3.7 0 0 1 .22-1.51l-.49-.34a9.63 9.63 0 0 1-1.46 3.13c-.63.89-2.18 2.7-3 .92a6.41 6.41 0 0 1-.09-3.37 3.37 3.37 0 0 1 1.42-2.53l-.37-.3a10.75 10.75 0 0 1-1.28 6.64 10.55 10.55 0 0 1-2.07 2.62c-.29.27-.64.68-1 .52s-.37-.83-.36-1.26a2.18 2.18 0 0 0-.26-1.26c0-.09-.19-.26-.31-.17a6.86 6.86 0 0 0-2.7 4.67l.44.18a4.45 4.45 0 0 0-.45-1.76c-.07-.13-.22-.25-.35-.13a5 5 0 0 0-1.79 3.44l.45.16a6.45 6.45 0 0 0-.67-2.65c-.07-.13-.23-.24-.37-.13a7.77 7.77 0 0 0-2.48 4l.37-.05c-.77-.89-.47-2.17-.22-3.21.07-.27-.38-.58-.47-.23a12.22 12.22 0 0 1-2.46 4.92c-.61.73-1.55 1.69-2.57 1.16s-1-2-.68-3a13.26 13.26 0 0 1 .45-1.25c.23-.49.93-1.16 1.15-.25a4.84 4.84 0 0 1-.5 2.69 12.39 12.39 0 0 1-3.28 4.22 2.77 2.77 0 0 1-2.58.92c-1.17-.4-.62-1.88-.29-2.72a6 6 0 0 1 1.47-2.34c.42-.36 1-.39 1.1.23a3.06 3.06 0 0 1-.14 1.27 7.77 7.77 0 0 1-2.51 3.93c-.73.6-4 2.64-4.47.94a6.43 6.43 0 0 1 .21-2.95 10.74 10.74 0 0 1 1-2.69 10.86 10.86 0 0 1 1.67-2.25 13.57 13.57 0 0 1 1.07-.94 4.67 4.67 0 0 1 .58-.41c.45-.27 1.51-.55 1.61.35 0 .21.26.22.27 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "136.224px 293.093px"
    },
    id: "elvgbhh5vjpw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83 279.4a2.69 2.69 0 0 0-1.42.75 3.33 3.33 0 0 0-.49.63 1.79 1.79 0 0 0-.28.83c0 .78 1 .76 1.53.49a3.89 3.89 0 0 0 1.19-1.13 1.33 1.33 0 0 0 .35-.8.89.89 0 0 0-.56-.83.4.4 0 0 0-.54.25c0 .08-.08.34 0 .38s.08-.05.11-.09c0 .05 0 .05 0 0h.28c.09 0 0 0 0 0v.05c0 .05 0 0 0 0v.07a1.53 1.53 0 0 1-.38.62 2.64 2.64 0 0 1-1.18.94.85.85 0 0 1-.36 0h-.07c.07 0 .17.12.14.18a1.66 1.66 0 0 0 .06-.21 2.43 2.43 0 0 1 .37-.69A2.6 2.6 0 0 1 153 280c.29-.08.09-.61-.18-.55Z",
    style: {
      fill: "#455a64",
      transformOrigin: "152.175px 280.788px"
    },
    id: "els5ees227t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43 266.42a12.55 12.55 0 0 0 4.38-1.2 18.25 18.25 0 0 0 4-2.06c.89-.65 2.27-1.74 2.3-3a1 1 0 0 0-.54-1c-.6-.3-1.28.19-1.75.54-2.2 1.62-3 4.43-3.89 6.9a17.18 17.18 0 0 1-1.64 3.72c-.66 1.07-1.78 2.45-3.08 2.74s0-1.65.37-2a5.86 5.86 0 0 1 2.11-1.31 12.54 12.54 0 0 1 5.71-.43c.24 0 .14-.39 0-.44-2.67-.68-6.38-.31-8.34 1.85-.58.64-1.5 2.16-.5 2.86s2.44-.68 3.06-1.29c1.95-1.95 2.59-4.74 3.52-7.24a12.61 12.61 0 0 1 1.86-3.56 6.35 6.35 0 0 1 1.49-1.39 2.07 2.07 0 0 1 .62-.33c.64 0 .52.33.41.63a3.58 3.58 0 0 1-.67 1 12 12 0 0 1-4.24 2.85 18.56 18.56 0 0 1-5.23 1.81c-.18 0-.11.39.07.38Z",
    style: {
      fill: "#455a64",
      transformOrigin: "179.116px 266.425px"
    },
    id: "elog06o9lzhqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11 265.88c.37-.89.84-2 1.93-2.17 1.58-.22 1.09 1.56 1.21 2.51 0 .21.34.5.43.17a7.49 7.49 0 0 1 1.61-3c.18-.2.47-.62.79-.38.12.09.16.41.21.56a2.78 2.78 0 0 0 .41.85c.09.13.33.17.36 0a4.9 4.9 0 0 1 2-3.4l-.22-.05a2.79 2.79 0 0 1 .72 1.23c0 .17.3.37.42.15l1.32-2.35-.44-.29a1.2 1.2 0 0 0 .83 1.25 1.72 1.72 0 0 0 1.77-.67 13.69 13.69 0 0 0 1.69-2.38c.33-.56 1.06-1.52.84-2.21a.89.89 0 0 0-1.18-.54c-.68.28-.85 1.22-.9 1.86-.1 1.05.32 3.73 2 3a6 6 0 0 0 2.12-2.18 11.1 11.1 0 0 0 1.4-2.95l-.43-.29a2.77 2.77 0 0 0 .53 2.34c.07.1.28.18.35 0a11.28 11.28 0 0 1 2.51-4l-.31-.07a3.63 3.63 0 0 1 .66 1.7c0 .15.29.51.41.23a10.2 10.2 0 0 1 1.06-1.91c.16-.21.35-.58.58-.71.56-.35.69.29.71.7 0 .21.34.5.42.18a8.42 8.42 0 0 1 2.32-4l-.38-.28a4.1 4.1 0 0 0 1.09 2.64.18.18 0 0 0 .25 0 18 18 0 0 0 4.18-5.87c.51-1.18 2-4.28.17-5.08a.18.18 0 0 0-.24.06 9.12 9.12 0 0 0-1.43 4.89c0 1.19.5 2.61 1.88 2.75 1.55.15 2.92-1.27 3.76-2.4a9.81 9.81 0 0 0 1.83-4.46c0-.18-.26-.58-.39-.29a4 4 0 0 0 0 3.32c0 .08.16.23.27.17a5.46 5.46 0 0 0 2.19-3.31c.21-.64.56-2.3-.59-2.3a.14.14 0 0 0-.12.08 3.73 3.73 0 0 0 0 2.84 2.16 2.16 0 0 0 2 1.54c.94-.11 1.7-1.07 2.2-1.78a7.53 7.53 0 0 0 1.28-3.13c0-.17-.27-.58-.37-.3a1 1 0 0 0 .89 1.33c1 .11 1.33-1 1.52-1.77l-.23.08a2.83 2.83 0 0 0 3.86-.79c.11-.17-.12-.56-.27-.34a2.66 2.66 0 0 1-3.48.71c-.1-.05-.21 0-.24.09a3.22 3.22 0 0 1-.41 1.08 1 1 0 0 1-.65.45c-.22 0-.78-.14-.64-.49l-.37-.3a7.14 7.14 0 0 1-1.58 3.45 3.46 3.46 0 0 1-1.4 1.15c-.86.27-1.54-.48-1.83-1.21-.15-.38-.46-1.87.07-2s0 1.19-.06 1.45a5 5 0 0 1-2 3l.28.17a3.28 3.28 0 0 1 0-2.82l-.39-.3a9.49 9.49 0 0 1-1.32 3.65 6.37 6.37 0 0 1-3 2.81 1.6 1.6 0 0 1-2-.52 3.4 3.4 0 0 1-.31-2 8.93 8.93 0 0 1 1.37-4.09l-.23.07c1 .42.35 2 .12 2.71a18.14 18.14 0 0 1-1.12 2.65 17.51 17.51 0 0 1-3.58 4.67h.26a3.28 3.28 0 0 1-.85-2.12c0-.16-.21-.44-.38-.28a8.94 8.94 0 0 0-2.41 4.15l.43.17c0-.56-.33-1.68-1.12-1.47-.48.13-.85.81-1.1 1.19a9.8 9.8 0 0 0-1 1.74l.41.23a4.38 4.38 0 0 0-.81-2.11c-.07-.1-.21-.17-.31-.07a11.52 11.52 0 0 0-2.59 4.1h.35a2.08 2.08 0 0 1-.36-1.79c0-.21-.35-.58-.44-.29a10.57 10.57 0 0 1-1.9 3.6c-.4.49-1.2 1.59-1.94 1.43s-.86-1.68-.81-2.31a3.15 3.15 0 0 1 .22-1c.08-.17.91-1.14 1-.28 0 .24-.29.64-.4.85s-.36.68-.57 1a13.83 13.83 0 0 1-1.22 1.73 3.22 3.22 0 0 1-.78.74c-.32.18-1.32.39-1.26-.35 0-.2-.27-.58-.43-.29l-1.22 2.39.42.15a3.74 3.74 0 0 0-.95-1.6.22.22 0 0 0-.23-.05 5.3 5.3 0 0 0-2.21 3.69h.36c-.38-.51-.52-2.23-1.57-1.6a4.71 4.71 0 0 0-1.27 1.53 8 8 0 0 0-.89 2.08l.43.17c-.13-1.12.33-2.84-1.24-3.13s-2.25 1.21-2.71 2.34c-.1.22.26.63.38.35Z",
    style: {
      fill: "#455a64",
      transformOrigin: "209.801px 251.567px"
    },
    id: "el6jc523bopec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.46 231.13a9 9 0 0 0 5.57-4.06 3 3 0 0 0 .6-2.25 1.12 1.12 0 0 0-1.79-.64 10.24 10.24 0 0 0-4 5.48 10.94 10.94 0 0 0-.56 3.26c0 .89 0 2.17 1 2.5 1.27.4 2.08-1 2.69-1.85q1.49-2.07 3-4.15l-.51-.14a7.19 7.19 0 0 1 .9 2.81c0 .24.48.63.59.24a13.39 13.39 0 0 1 2.55-4.87h-.39a3.16 3.16 0 0 1 1 2.17c0 .24.45.62.58.24a10.37 10.37 0 0 1 2.34-4l-.45-.2.48.86c.11.2.4.37.52.09a10.18 10.18 0 0 1 2.14-3.14l-.49-.36a1.72 1.72 0 0 0 1.13 1.59 2.44 2.44 0 0 0 2.43-.57 9.39 9.39 0 0 0 3.5-5.05c.15-.71.27-1.7-.33-2.24s-1.21-.22-1.62.31a4.88 4.88 0 0 0-.8 2.43 3.46 3.46 0 0 0 .39 2.34c1.25 1.92 3.65.83 5-.35.17-.16-.07-.6-.29-.44-1.09.81-3.59 2.18-4.4.3a4 4 0 0 1 0-2.38c.12-.52.43-1.82 1.14-1.87 1-.07.25 2.19.08 2.6a8.25 8.25 0 0 1-1.37 2.13 10.11 10.11 0 0 1-1.84 1.8 2.2 2.2 0 0 1-1.38.51 1 1 0 0 1-1.05-.93c0-.18-.29-.56-.48-.37a10.77 10.77 0 0 0-2.29 3.37l.52.09c-.15-.29-.31-.58-.47-.87-.07-.11-.31-.36-.46-.2a11.09 11.09 0 0 0-2.5 4.18l.57.25a4.09 4.09 0 0 0-1.32-2.78.27.27 0 0 0-.4 0 13.87 13.87 0 0 0-2.62 5l.59.24a8 8 0 0 0-1-3.13c-.1-.17-.37-.36-.52-.14-.64.88-1.27 1.77-1.9 2.66a26.48 26.48 0 0 1-1.91 2.64c-.28.3-.87.79-1.32.54s-.45-1.22-.44-1.72a10.28 10.28 0 0 1 .38-2.65 10.82 10.82 0 0 1 2.63-4.6c.38-.38 2.26-2.18 2.32-.78a3.82 3.82 0 0 1-1 2.25 10.1 10.1 0 0 1-4.78 3.4c-.18.06-.1.45.09.41Z",
    style: {
      fill: "#455a64",
      transformOrigin: "253.134px 226.031px"
    },
    id: "elavh4lcgsl0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14 338a8.7 8.7 0 0 1 3.83-4c.45-.24 1.47-.79 1.62 0a8.33 8.33 0 0 1 0 1.58 22.9 22.9 0 0 1-.33 3.5c0 .2.32.59.42.29a12.09 12.09 0 0 1 1.14-2.48c.17-.28.48-1 .79-1.13.7-.32 1 1.08 1.1 1.44 0 .21.34.38.42.11a7.11 7.11 0 0 1 2.7-3.84l-.33-.14a2.5 2.5 0 0 1 .2 1.15c0 .19.24.44.39.23.36-.51.72-1 1.07-1.52l-.38-.17c.16.54.53 1.43 1.22 1.37a1.25 1.25 0 0 0 .74-.48c.42-.43.82-.89 1.2-1.36a18.36 18.36 0 0 0 1.73-2.63c.4-.75 1.07-1.81.89-2.7-.12-.62-.74-1.2-1.37-.86a4.16 4.16 0 0 0-1.36 2.26c-.35 1.09-.86 4.12 1.16 4 1-.09 1.82-1.1 2.38-1.88a13.5 13.5 0 0 0 1.71-3.2l-.4-.23a5 5 0 0 0 .71 2.54.18.18 0 0 0 .32 0c.6-.9 1.2-1.8 1.79-2.7h-.28l.83.83c.1.09.28.09.3-.07.12-.95 1.32-1 2.05-1.06a1.89 1.89 0 0 0 1.6-.85c.07-.14-.13-.47-.25-.29-.8 1.23-3.53.14-3.77 2l.3-.07-.83-.83a.17.17 0 0 0-.28 0c-.6.9-1.2 1.8-1.79 2.7h.32a4.17 4.17 0 0 1-.57-2.15c0-.15-.3-.49-.39-.23a11 11 0 0 1-2.63 4.27c-.78.71-2.09 1-2.17-.44a5.79 5.79 0 0 1 .55-2.65 4.59 4.59 0 0 1 .68-1.2c.29-.33.29-.35.69 0 .33.11.42.31.29.6a2.6 2.6 0 0 1-.15.42 16 16 0 0 1-1.1 2.19 18.22 18.22 0 0 1-1.58 2.22c-.28.32-.56.64-.86.94s-.21.26-.61.21-.52-.25-.64-.67c-.05-.17-.24-.37-.38-.17-.36.51-.72 1-1.07 1.52l.39.23a3.32 3.32 0 0 0-.26-1.42c-.06-.13-.2-.23-.33-.14a7.43 7.43 0 0 0-2.82 4l.41.11c-.11-.63-.83-2.65-1.77-1.92a5.59 5.59 0 0 0-1.14 1.65 11.67 11.67 0 0 0-.93 2.11l.42.29a23.37 23.37 0 0 0 .31-4.58c0-.76-.12-2-1.21-1.75a7.31 7.31 0 0 0-3 1.79 8.74 8.74 0 0 0-2 3c-.08.19.19.5.31.24Z",
    style: {
      fill: "#455a64",
      transformOrigin: "133.915px 332.569px"
    },
    id: "el83ymn13cjvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.32 304.19a12.92 12.92 0 0 0 2.85-4.79c.05-.13-.13-.48-.3-.37a15.48 15.48 0 0 0-6.59 8.79c-.39 1.39-.85 3.43 1.06 3.84 1.73.37 3.45-1.52 4.49-2.65a17 17 0 0 0 3.51-5.76l-.44-.29a5.44 5.44 0 0 0 .12 3.22c0 .11.27.4.4.2.64-1 1.28-2.06 1.93-3.09l-.37-.12c.36.57.72 1.14 1.07 1.71.07.1.25.27.37.13.41-.49.62-1.3 1.22-1.59.41-.19.73-.08.78.4a2.4 2.4 0 0 0 .14.8c.08.18.36.26.41 0a5.54 5.54 0 0 1 1.89-3.18l-.36-.13a1.72 1.72 0 0 1 .26 1c0 .19.29.59.43.29a15.64 15.64 0 0 1 2.18-3.44L192 299a2.42 2.42 0 0 0 .88 1.67c.71.43 1.4-.23 1.93-.66a11.73 11.73 0 0 0 3.43-4.68 1.77 1.77 0 0 0 .05-1.75c-.48-.62-.89.06-1.13.51a4.86 4.86 0 0 0 .12 4.8c.06.09.18.23.31.16 2-1.09 3-3.52 4-5.44a14.87 14.87 0 0 0 2-7.32c0-.21-.34-.49-.42-.17a38 38 0 0 0-.9 4.47 18 18 0 0 0-.31 4.2c.09.82.72 1.39 1.48.82a13.31 13.31 0 0 0 2.81-3l-.33-.06a2.32 2.32 0 0 0 1.29.7c.33.06.21-.5 0-.55a1.68 1.68 0 0 1-1-.49c-.08-.07-.24-.18-.34-.05a16.22 16.22 0 0 1-2 2.35c-.36.34-1.11 1.25-1.4.41a5.33 5.33 0 0 1 0-1.78 34.13 34.13 0 0 1 1.12-6.74l-.43-.18a14.56 14.56 0 0 1-2 7c-.52 1-1.06 2-1.65 3a6.35 6.35 0 0 1-2.24 2.39l.31.17a4.24 4.24 0 0 1-.42-3.54 4.8 4.8 0 0 1 .33-.73c0-.06.23-.49.31-.48s.19.23.18.36a4.67 4.67 0 0 1-.71 1.73 11.53 11.53 0 0 1-2.21 2.93 5.54 5.54 0 0 1-1.6 1.22c-.76.27-1-.67-1.11-1.24 0-.14-.25-.36-.38-.2a15.72 15.72 0 0 0-2.26 3.53l.43.29a2.41 2.41 0 0 0-.33-1.46c-.08-.13-.23-.25-.36-.13a5.91 5.91 0 0 0-2 3.4h.41c-.18-.41 0-.86-.25-1.26a.9.9 0 0 0-.71-.39c-1.06-.06-1.36 1.13-1.91 1.78l.37.13-1.01-1.72c0-.08-.26-.29-.36-.12-.65 1-1.29 2-1.94 3.08l.4.2a4.92 4.92 0 0 1-.09-2.94c0-.21-.34-.58-.44-.29a16.48 16.48 0 0 1-3.31 5.51 12.71 12.71 0 0 1-2.51 2.24c-1 .65-2.93.84-2.74-.92.46-4.11 3.33-8 6.72-10.2l-.3-.37a13.2 13.2 0 0 1-2.65 4.72c-.11.12 0 .47.19.31Z",
    style: {
      fill: "#455a64",
      transformOrigin: "190.174px 298.841px"
    },
    id: "elbgd5zuv9t3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29 276.74c-.54.54 0 1.45.66 1.56 1.06.18 1.83-1.2 2.28-1.95a21.51 21.51 0 0 0 2.2-7.46l-.47-.15a16.65 16.65 0 0 0 1.61 6.24c.1.18.38.26.43 0q.52-2.79 1.21-5.54c.29-1.19.73-4.8 2.74-4 .23.09.19-.29.06-.38a1.44 1.44 0 0 0-1.81.19 4.91 4.91 0 0 0-1.12 2.58q-.9 3.46-1.56 7h.48a15.8 15.8 0 0 1-1.52-5.94c0-.22-.41-.51-.47-.15a31.35 31.35 0 0 1-1.13 5 12.82 12.82 0 0 1-1 2.21 7 7 0 0 1-.76 1.11 2.32 2.32 0 0 1-.5.49 1 1 0 0 1-.35.22q-.87.17-.72-.63c.07-.12-.07-.53-.23-.37Z",
    style: {
      fill: "#455a64",
      transformOrigin: "236.592px 271.57px"
    },
    id: "elj8x318klmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19 267.34c-1.51.54-2.08 2.34-2.12 3.81 0 .56.1 1.44.86 1.43s1.32-1.17 1.62-1.74a7.88 7.88 0 0 0 .84-2.62c.07-.54.12-1.54-.61-1.68s-.91 1.08-1 1.55a2.25 2.25 0 0 0 .6 2.2 1.54 1.54 0 0 0 2.17-.32 6.81 6.81 0 0 0 1.46-3l-.45-.21c0 .6 0 1.25.09 1.85.05.27.21.64.54.64s.55-.69.64-1l.57-1.95h-.3c.26.25.25.67.54.91a1.2 1.2 0 0 0 .67.27 2 2 0 0 0 1.59-.87c.12-.14 0-.56-.21-.4a2.17 2.17 0 0 1-1.46.73c-.59-.05-.58-.7-.94-1.05-.08-.08-.26-.1-.3 0-.23.77-.45 1.54-.68 2.31 0 .07-.06.36-.21.34s0-.45 0-.53l-.06-1.22c0-.17-.37-.51-.45-.22a7.73 7.73 0 0 1-1 2.41c-.38.55-1.17 1.34-1.88.84s-.41-1.79-.12-2.46c.07-.14.17-.45.39-.18.09.11 0 .46 0 .58a6.62 6.62 0 0 1-.23 1.16 7.28 7.28 0 0 1-1 2.08c-.2.3-.52.91-.93.81q-.24 0-.21-.18a1.42 1.42 0 0 1 0-.29 4.53 4.53 0 0 1 0-.52 3.94 3.94 0 0 1 1.79-3.14c.15-.1 0-.5-.18-.43Z",
    style: {
      fill: "#455a64",
      transformOrigin: "246.009px 269.201px"
    },
    id: "eliazfbs0xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-149",
    className: "animable",
    style: {
      transformOrigin: "188.811px 104.23px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "188.193px 103.685px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.1 65.68V80.9a13.05 13.05 0 0 1-6 10.33l-29.46 17c-1.46.84-2.29 2.52-3.16 4.29a16.66 16.66 0 0 1-2.28 3.72c-2.28 2.59-7.28 5.3-10.8 6.42a20 20 0 0 1-3.53.82c-.45.07-.94.14-1.45.2-3.21.43-7.21 1-9.56 2.33l-34.47 19.9a6.1 6.1 0 0 1-3 .9 4 4 0 0 1-2-.52 5 5 0 0 1-2.19-4.54v-15.21a13 13 0 0 1 6-10.33l11.58-6.69a.76.76 0 0 1 .16-.06 1.22 1.22 0 0 1 1.21 2.09.49.49 0 0 1-.14.11l-11.57 6.68a10.68 10.68 0 0 0-4.74 8.2v15.21a2.08 2.08 0 0 0 3.5 2l34.47-19.91c2.77-1.59 7.05-2.17 10.47-2.63.51-.06 1-.14 1.43-.2a18.68 18.68 0 0 0 3.14-.73c3.13-1 7.77-3.52 9.69-5.69a14.72 14.72 0 0 0 1.91-3.19c1-2 2-4.12 4.14-5.33l29.46-17a10.65 10.65 0 0 0 4.73-8.19v-15.2a2.07 2.07 0 0 0-3.49-2l-10 5.79a10.06 10.06 0 0 0-1.26-2.12l10.06-5.81a4.46 4.46 0 0 1 7.2 4.15Z",
    id: "elvo06rfw2m8f",
    className: "animable",
    style: {
      transformOrigin: "188.193px 103.685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-149",
    className: "animable",
    style: {
      transformOrigin: "189.45px 104.772px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.62 66a3.06 3.06 0 0 1 3.11.29 9.68 9.68 0 0 1 4.38 7.59 3.08 3.08 0 0 1-1.3 2.84l-69.89 40.36-6.19-10.73Z",
    style: {
      fill: "#37474f",
      transformOrigin: "189.428px 91.3925px"
    },
    id: "elz9taucuw2bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.84 111.71 73-42.15a9 9 0 0 0-3.11-3.3c-.15-.08-.28-.13-.42-.19l-71.86 41.49Z",
    style: {
      fill: "#455a64",
      transformOrigin: "189.145px 88.89px"
    },
    id: "el4rntrnty9go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.84 106.62c-2.42-1.4-4.38-.27-4.38 2.53a9.68 9.68 0 0 0 4.38 7.58c2.42 1.4 4.38.26 4.38-2.53a9.66 9.66 0 0 0-4.38-7.58Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.84px 111.674px"
    },
    id: "elw5e2n2m5l5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35 66.76V82a13 13 0 0 1-6 10.33l-29.46 17c-1.46.84-2.29 2.53-3.16 4.29a16.66 16.66 0 0 1-2.28 3.72c-2.28 2.6-7.27 5.3-10.8 6.43a20.86 20.86 0 0 1-3.53.81c-.44.08-.94.14-1.45.2-3.21.43-7.21 1-9.56 2.34L142.67 147a6.1 6.1 0 0 1-3 .9 4 4 0 0 1-2-.52 4.93 4.93 0 0 1-2.19-4.53v-15.23a13 13 0 0 1 6-10.33L153 110.6l.16-.06a1.22 1.22 0 0 1 1.21 2.09.36.36 0 0 1-.14.11l-11.57 6.69a10.66 10.66 0 0 0-4.74 8.19v15.22a2.08 2.08 0 0 0 3.5 2l34.48-19.91c2.76-1.59 7-2.17 10.46-2.63l1.43-.19a19.71 19.71 0 0 0 3.14-.73c3.13-1 7.77-3.53 9.69-5.7a15.14 15.14 0 0 0 1.92-3.19c1-2 2-4.11 4.13-5.32l29.46-17a10.64 10.64 0 0 0 4.74-8.17V66.76a2.07 2.07 0 0 0-3.49-2l-10 5.8a9.88 9.88 0 0 0-1.26-2.13l10.06-5.81a4.47 4.47 0 0 1 7.21 4.15Z",
    style: {
      fill: "#455a64",
      transformOrigin: "189.45px 104.772px"
    },
    id: "el2lngnt6x54",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "241.639px 425.682px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "241.639px 425.682px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m276.53 438.59-3.32 2a6.76 6.76 0 0 1-6.12.34l-36.67-17.44c-2.1-1.21-1.85-3.1-1.61-4.93s.44-3.33-1.11-4.23c-4.42-2.55-13.46-1.14-18.59 1.82s-7.57 8.18-3.15 10.73c1.55.9 4.36.78 7.32.64 3.17-.14 6.46-.28 8.55.93l.09.06 29.78 21c1.76 1.05 1.22 2.75-.41 3.68l-3.29 1.9-1.94-1.09 3.29-1.9c.71-.41 1-1.15.36-1.53l-.09-.06-29.77-21c-1.24-.68-3.76-.57-6.41-.46-3.28.15-7 .31-9.42-1.09-2.62-1.51-3.62-3.77-2.83-6.38.73-2.38 2.91-4.76 6-6.53a29.31 29.31 0 0 1 11.32-3.45c4.51-.46 8.43.12 11 1.63 2.42 1.4 2.14 3.54 1.89 5.43-.2 1.54-.39 3 .79 3.71l36.39 17h.05a3.53 3.53 0 0 0 2.83-.06l3.15-1.81Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "238.728px 433.268px"
    },
    id: "ell2ltyciexq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.53 438.59-3.32 2a6.76 6.76 0 0 1-6.12.34l-36.67-17.44c-2.1-1.21-1.85-3.1-1.61-4.93s.44-3.33-1.11-4.23c-4.42-2.55-13.46-1.14-18.59 1.82s-7.57 8.18-3.15 10.73c1.55.9 4.36.78 7.32.64 3.17-.14 6.46-.28 8.55.93l.09.06 29.78 21c1.76 1.05 1.22 2.75-.41 3.68l-3.29 1.9-1.94-1.09 3.29-1.9c.71-.41 1-1.15.36-1.53l-.09-.06-29.77-21c-1.24-.68-3.76-.57-6.41-.46-3.28.15-7 .31-9.42-1.09-2.62-1.51-3.62-3.77-2.83-6.38.73-2.38 2.91-4.76 6-6.53a29.31 29.31 0 0 1 11.32-3.45c4.51-.46 8.43.12 11 1.63 2.42 1.4 2.14 3.54 1.89 5.43-.2 1.54-.39 3 .79 3.71l36.39 17h.05a3.53 3.53 0 0 0 2.83-.06l3.15-1.81Z",
    style: {
      opacity: 0.1,
      transformOrigin: "238.728px 433.268px"
    },
    className: "animable",
    id: "eljzqhnyvd3yo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57 454.27a4.49 4.49 0 0 0-2-3.52 1.42 1.42 0 0 0-1.45-.14l-7.5 4.32 2.86 5 7.55-4.36a1.44 1.44 0 0 0 .54-1.3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "246.1px 455.202px"
    },
    id: "ellz18dso33tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 459.78c1.12.64 2 .12 2-1.18a4.47 4.47 0 0 0-2-3.51c-1.12-.65-2-.13-2 1.17a4.51 4.51 0 0 0 2 3.52Z",
    style: {
      fill: "#263238",
      transformOrigin: "242px 457.432px"
    },
    id: "elln79afzify",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16 458.12c.37.22.67 0 .67-.38a1.47 1.47 0 0 0-.67-1.16c-.37-.22-.67 0-.67.38a1.47 1.47 0 0 0 .67 1.16Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "242.16px 457.35px"
    },
    id: "elwnnzw2iak2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34 436.5a4.47 4.47 0 0 0-2-3.51 1.42 1.42 0 0 0-1.45-.14l-7.5 4.32 2.86 5 7.55-4.35a1.44 1.44 0 0 0 .54-1.32Z",
    style: {
      fill: "#37474f",
      transformOrigin: "276.871px 437.442px"
    },
    id: "elgr5vnzn4i9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.78 442c1.12.65 2 .13 2-1.17a4.51 4.51 0 0 0-2-3.52c-1.12-.64-2-.12-2 1.18a4.47 4.47 0 0 0 2 3.51Z",
    style: {
      fill: "#263238",
      transformOrigin: "272.78px 439.658px"
    },
    id: "elx8y0p5gllq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.41 440.39a.48.48 0 0 0 .18-.42 1.5 1.5 0 0 0-.67-1.16.45.45 0 0 0-.48 0l-.88.5a2.31 2.31 0 0 1-1 .31l.2 1.85a5.08 5.08 0 0 0 1.89-.62l.7-.41Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "272.076px 440.105px"
    },
    id: "el7h76ms8dsmx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.41 440.39a.48.48 0 0 0 .18-.42 1.5 1.5 0 0 0-.67-1.16.45.45 0 0 0-.48 0l-.88.5a2.31 2.31 0 0 1-1 .31l.2 1.85a5.08 5.08 0 0 0 1.89-.62l.7-.41Z",
    style: {
      opacity: 0.1,
      transformOrigin: "272.076px 440.105px"
    },
    className: "animable",
    id: "eley6j0j7sta"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6 442.06c0-.94-.72-1.4-1.07-1.2l-10.81 6.24c1-.57 1.61.85 1.68 1.42a8.53 8.53 0 0 1 .07 1.83c-.07.9.36 1.2 1.08.79l6.9-4a4.64 4.64 0 0 0 1.5-1.92 7.63 7.63 0 0 0 .65-3.16Z",
    style: {
      fill: "#37474f",
      transformOrigin: "261.66px 446.067px"
    },
    id: "elmry5c9xf0dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "253.325px 431.305px"
    },
    id: "elpwi6k4z4h",
    className: "animable",
    d: "m281.93 431.96-39.98 23.1-17.23-9.87v-14.6l39.91-23.04-6.47 15.38 23.77 9.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.63 407.55-39.91 23L240.39 452l11.61-6.73.76 1s2.2 1.81 3.6 1l1-.58 10.4-6 1-.58c1.4-.81.43-3.32.43-3.32l-.76-1 11.9-6.87Z",
    style: {
      fill: "#37474f",
      transformOrigin: "252.525px 429.775px"
    },
    id: "elydr5g29iy7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276 433.87-3.28 1.9c-1.63.94-4.09 1-5.19-.46L242 407c-1.24-1.7-.38-3.95.45-6.12s1.52-3.95.59-5.21c-2.63-3.58-10.34-2.95-15.47 0s-8.9 9-6.27 12.53c.93 1.26 3.21 1.44 5.62 1.63 2.58.2 5.25.41 6.5 2.11l.05.08 18.86 32.09c1 1.47 0 3.45-1.61 4.39l-3.29 1.89-1.13-1.53 3.29-1.9c.71-.41 1.21-1.27.82-1.8v-.08L231.47 413c-.75-1-2.79-1.13-5-1.3-2.66-.21-5.69-.44-7.13-2.41s-1.57-5 0-8a18.35 18.35 0 0 1 7.06-7.16 21.43 21.43 0 0 1 10.24-2.82c3.76 0 6.69 1.13 8.25 3.25 1.45 2 .47 4.51-.39 6.75-.7 1.82-1.36 3.54-.67 4.54l25.5 28.31c.4.53 1.49.47 2.2.06l3.29-1.9Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "247.105px 420.85px"
    },
    id: "elwymq28tm9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57 449.22a4.47 4.47 0 0 0-2-3.51 1.42 1.42 0 0 0-1.45-.14l-7.5 4.32 2.86 5 7.55-4.35a1.44 1.44 0 0 0 .54-1.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "246.101px 450.162px"
    },
    id: "elrj4tqpspoke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 454.73c1.12.65 2 .13 2-1.17a4.51 4.51 0 0 0-2-3.52c-1.12-.64-2-.12-2 1.18a4.47 4.47 0 0 0 2 3.51Z",
    style: {
      fill: "#263238",
      transformOrigin: "242px 452.388px"
    },
    id: "elsvk0q6y7fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16 453.08c.37.21.67 0 .67-.39a1.5 1.5 0 0 0-.67-1.16c-.37-.21-.67 0-.67.39a1.47 1.47 0 0 0 .67 1.16Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "242.16px 452.305px"
    },
    id: "el28jkc0mnhw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34 431.46a4.51 4.51 0 0 0-2-3.52 1.44 1.44 0 0 0-1.45-.13l-7.5 4.32 2.86 5 7.55-4.35a1.46 1.46 0 0 0 .54-1.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.87px 432.401px"
    },
    id: "elbzd7nr3p4xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.78 437c1.12.65 2 .12 2-1.17a4.49 4.49 0 0 0-2-3.52c-1.12-.65-2-.12-2 1.17a4.49 4.49 0 0 0 2 3.52Z",
    style: {
      fill: "#263238",
      transformOrigin: "272.78px 434.655px"
    },
    id: "elnasarfp80rd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92 435.32c.37.21.67 0 .67-.39a1.49 1.49 0 0 0-.67-1.16c-.36-.21-.66 0-.66.39a1.5 1.5 0 0 0 .66 1.16Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "272.925px 434.545px"
    },
    id: "ell13lccjn4zs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.44 433.73-.88.51a2.64 2.64 0 0 1-1 .31l.2 1.85a5.09 5.09 0 0 0 1.89-.63l.73-.42Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "271.97px 435.065px"
    },
    id: "el1gsxtwaybd1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 439.57a1.43 1.43 0 0 1-.57 1.29l-10.81 6.24a2.88 2.88 0 0 0 .87-1.76 10.51 10.51 0 0 0 .07-1.91 2.16 2.16 0 0 1 1.08-2l6.9-4a1.25 1.25 0 0 1 1.5.18 2.91 2.91 0 0 1 .96 1.96Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.314px 442.179px"
    },
    id: "elx36hh0zuyym",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-149",
    className: "animable",
    style: {
      transformOrigin: "371.189px 265.61px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-149",
    className: "animable",
    style: {
      transformOrigin: "371.189px 265.61px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-149",
    className: "animable",
    style: {
      transformOrigin: "371.189px 179.262px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m258.77 259.33-3.43 2.5c-1.5 1.1-4.63 4.65-3.76 5.83s5.19-.73 6.69-1.82l3.43-2.51a6.35 6.35 0 0 1-.69-.68l-.3-.36c-.28-.34-.5-.66-.63-.83a10.71 10.71 0 0 1-1.3-2.13",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "256.565px 263.681px"
    },
    id: "el4d3u8umt0jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.77 259.33-3.43 2.5c-1.5 1.1-4.63 4.65-3.76 5.83s5.19-.73 6.69-1.82l3.43-2.51a6.35 6.35 0 0 1-.69-.68l-.3-.36c-.28-.34-.5-.66-.63-.83a10.71 10.71 0 0 1-1.3-2.13",
    style: {
      opacity: 0.15,
      transformOrigin: "256.565px 263.681px"
    },
    className: "animable",
    id: "elubgjg131cvm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.28 268c-.79.13-1.42.07-1.7-.31s-.16-.94.16-1.6a2.16 2.16 0 0 0 1.54 1.91Z",
    style: {
      fill: "#263238",
      transformOrigin: "252.352px 267.076px"
    },
    id: "elp9qah3d5q2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.44 233.18c1.51-1.14 3.76-1.27 6.43-.08 5.25 2.31 10 8.86 10.59 14.59.29 2.84-.47 4.94-2 6.05h-.05c-5.32 3.85-21.68 11.92-30.17 11.79a3.83 3.83 0 0 1-1.44-.43 7.38 7.38 0 0 1-3.92-5.41 3 3 0 0 1 .13-1.31c2.44-8.12 15.18-21.38 20.43-25.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "275.689px 248.898px"
    },
    id: "elg3qnfv0dxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.73 229.15 1.47 2a10 10 0 0 1 2.83.8c5.39 2.39 10.29 9.07 10.92 14.94a9.75 9.75 0 0 1-.09 2.94l1.46 2-4.28 1.8a7.15 7.15 0 0 1-5.7-.43c-5.4-2.38-10.29-9.06-10.93-14.93a7.14 7.14 0 0 1 1.33-5.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "286.809px 241.59px"
    },
    id: "elmk0stya0wu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.73 229.15 1.47 2a10 10 0 0 1 2.83.8c5.39 2.39 10.29 9.07 10.92 14.94a9.75 9.75 0 0 1-.09 2.94l1.46 2-4.28 1.8a7.15 7.15 0 0 1-5.7-.43c-5.4-2.38-10.29-9.06-10.93-14.93a7.14 7.14 0 0 1 1.33-5.56Z",
    style: {
      opacity: 0.15,
      transformOrigin: "286.809px 241.59px"
    },
    className: "animable",
    id: "elvs8gecv5rv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61 167.61c5.87 2.59 11.18 9.85 11.87 16.22.34 3.18-.53 5.54-2.23 6.78l-82.86 60.63c-1.69 1.24-4.21 1.36-7.14.07-5.86-2.59-11.17-9.85-11.86-16.22-.34-3.18.53-5.54 2.22-6.78l82.87-60.63c1.69-1.24 4.2-1.36 7.13-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.435px 209.46px"
    },
    id: "ell83podt2j4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61 167.61c5.87 2.59 11.18 9.85 11.87 16.22.34 3.18-.53 5.54-2.23 6.78l-82.86 60.63c-1.69 1.24-4.21 1.36-7.14.07-5.86-2.59-11.17-9.85-11.86-16.22-.34-3.18.53-5.54 2.22-6.78l82.87-60.63c1.69-1.24 4.2-1.36 7.13-.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "331.435px 209.46px"
    },
    className: "animable",
    id: "el6qmt4vn8tc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.12 190.68c-5.86-2.59-11.17-9.85-11.87-16.22-.34-3.18.53-5.54 2.23-6.78s4.2-1.36 7.13-.07c5.87 2.59 11.18 9.85 11.87 16.22.34 3.18-.53 5.54-2.23 6.78s-4.2 1.39-7.13.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "372.865px 179.151px"
    },
    id: "eltc1pc4klj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74 161.94c6.76 3 12.9 11.37 13.69 18.72.4 3.67-.61 6.4-2.56 7.83l-7.07 5.17c-1.95 1.43-4.85 1.57-8.24.07-6.76-3-12.89-11.36-13.69-18.71-.4-3.68.61-6.4 2.57-7.83l7.06-5.19c1.96-1.41 4.86-1.55 8.24-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "374.65px 177.838px"
    },
    id: "elvqcuftkbso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74 161.94c6.76 3 12.9 11.37 13.69 18.72.4 3.67-.61 6.4-2.56 7.83l-7.07 5.17c-1.95 1.43-4.85 1.57-8.24.07-6.76-3-12.89-11.36-13.69-18.71-.4-3.68.61-6.4 2.57-7.83l7.06-5.19c1.96-1.41 4.86-1.55 8.24-.06Z",
    style: {
      fill: "#fff",
      opacity: 0.35,
      transformOrigin: "374.65px 177.838px"
    },
    className: "animable",
    id: "el5p00vi20pum"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63 188.56c-6.77-3-12.9-11.36-13.7-18.71-.39-3.68.62-6.4 2.57-7.83s4.86-1.57 8.24-.08c6.76 3 12.9 11.37 13.69 18.72.4 3.67-.61 6.4-2.56 7.83s-4.87 1.57-8.24.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "378.182px 175.254px"
    },
    id: "el126lkoyxywro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.81 94.24c6.58 2.9 12.54 11.05 13.32 18.2.39 3.58-.6 6.23-2.5 7.62l-91.87 67.22c-1.9 1.39-4.72 1.53-8 .07-6.59-2.9-12.55-11-13.33-18.2-.38-3.58.6-6.22 2.5-7.62l91.87-67.22c1.89-1.39 4.72-1.53 8.01-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "425.282px 140.795px"
    },
    id: "elnqrsr0hmfvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.81 94.24c6.58 2.9 12.54 11.05 13.32 18.2.39 3.58-.6 6.23-2.5 7.62l-91.87 67.22c-1.9 1.39-4.72 1.53-8 .07-6.59-2.9-12.55-11-13.33-18.2-.38-3.58.6-6.22 2.5-7.62l91.87-67.22c1.89-1.39 4.72-1.53 8.01-.07Z",
    style: {
      fill: "#fff",
      opacity: 0.35,
      transformOrigin: "425.282px 140.795px"
    },
    className: "animable",
    id: "elkge7ggxxxqr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.79 94.31a16 16 0 1 1 18.84 25.75c-1.9 1.39-4.72 1.52-8 .07-6.58-2.9-12.55-11-13.32-18.2-.39-3.58.59-6.23 2.49-7.62Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "473.712px 105.812px"
    },
    id: "el2sdnylc4ck5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.83 140.24-.42-3.46-10.41-4.4-59.22 44.87c-1.39 1.06-2 2.28-1.86 3.38.08.58.35 2.84.42 3.44a3.32 3.32 0 0 0 2.27 2.49 11.21 11.21 0 0 0 10.05-1.45Z",
    style: {
      fill: "#263238",
      transformOrigin: "433.865px 159.767px"
    },
    id: "elaboi97611ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15 180.71c-2.66 2-2.48 4.64.41 5.85a11.21 11.21 0 0 0 10.05-1.45l59.22-44.87-10.46-4.41Z",
    style: {
      fill: "#37474f",
      transformOrigin: "434.049px 161.492px"
    },
    id: "elxt8glm5ze2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "463.895px 132.405px"
    },
    id: "el62hkvuq9a7i",
    className: "animable",
    d: "m457.96 124.57 1.41 11.26 10.46 4.41-1.41-11.26-10.46-4.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "457.535px 131.06px"
    },
    id: "elga7cswy4imk",
    className: "animable",
    d: "m457.96 124.57-2.26 1.72 1.41 11.26 2.26-1.72-1.41-11.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.79 92.35a5.13 5.13 0 0 1 6.06 8.29l-4.17 3.06a2.57 2.57 0 0 1-2.58 0 8 8 0 0 1-4.29-5.86 2.56 2.56 0 0 1 .8-2.46l4.17-3.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "484.353px 97.7039px"
    },
    id: "elami3bvqil8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.81 97.86a2.55 2.55 0 0 1 .8-2.46l4.17-3.05a5.11 5.11 0 0 1 4.95-.61c-1.41-.35-3.39 1.12-5.7 2.81s-3.34 3.62-1 7.14c1.72 2.57 3.33 2.11 4.08 1.67l-.46.34a2.57 2.57 0 0 1-2.58 0 8 8 0 0 1-4.26-5.84Z",
    style: {
      fill: "#37474f",
      transformOrigin: "482.74px 97.7045px"
    },
    id: "elkt8db3wlieh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "368.331px 265.61px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-149",
    className: "animable",
    style: {
      transformOrigin: "390.542px 340.196px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.79 432.74c-.84-.08-.86 2-.33 2.95 1.49 2.83 5.65 5.87 11.74 7.21s18-.26 21.62-.4 9.85 1.7 13.45 2.28c6.55 1.06 11-.76 13.18-2.86a4 4 0 0 0 .9-3.1c-.06-2.49-.28-3-.56-3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "351.744px 438.915px"
    },
    id: "el2vokijie8jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.08 428.58a30.86 30.86 0 0 1 .58 9c-.76 1.85-2.79 2.91-4.42 3.42-4.28 1.34-8.48 1.08-13.2.07a34.54 34.54 0 0 0-9.3-1.06c-3.73.2-11.95 1-15.69 1.09a25.6 25.6 0 0 1-10.18-2c-2.47-1.15-6.22-3.69-7.05-5.61-.81-4.48-.35-7.14 2.23-8.66s6.62-1.92 12-2.33c1.61-.12 3.64-.21 4.51-.3 3.26-.36 6.3-.61 8.77-.76a14.2 14.2 0 0 0 6.1-1.33 4.12 4.12 0 0 0 2-1.95c.52-1.15.51-2.82 1.51-2.91 0 0 18.44 3.13 19.93 3.29 1.73.2.61 2.66 2.21 10.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "351.61px 428.584px"
    },
    id: "eldv23gsmya7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14 422.05a5 5 0 0 0-1.36 1.62 9.19 9.19 0 0 0-.85 2.14c-.24.94.92 1.13 1.37.05a12.06 12.06 0 0 1 1.32-2.56 3 3 0 0 1 1.6-1.15l.94-.09c-.25-.7-2.31-.48-3.02-.01Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "339.529px 424.104px"
    },
    id: "elf5blc2xzwi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46 421.09a2.24 2.24 0 0 0-1.74.52 4.39 4.39 0 0 0-1.3 1.95 16.76 16.76 0 0 0-.74 2.78c-.07.61 1.35.59 1.51-.07a23.8 23.8 0 0 1 .72-2.54c.16-.42.9-2 1.88-2.16h.45c0-.21-.28-.35-.48-.4a1.57 1.57 0 0 0-.3-.08Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "345.959px 423.927px"
    },
    id: "elijmzm4n4eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34 420.94a1.86 1.86 0 0 0-1.08.63 5 5 0 0 0-.76 1.46 9.79 9.79 0 0 0-.43 3c0 .78 1.39.57 1.44.05.15-1.64.15-2.72.93-3.91a3.85 3.85 0 0 1 1.23-1.29c0-.14-.25-.15-.39-.13a7.93 7.93 0 0 0-.94.19Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "351.87px 423.643px"
    },
    id: "el1rzp47wudc8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.74 398.7s-1.59 17-2 20.88c-.13 1.25-2.5 1.76-3.72 2.29a14.64 14.64 0 0 0-4.19 2.41c-3.1 3.08-5.43 3.8-7.3-1.6-.38-1.1-1.09-1.58-2.51-1.32a8.42 8.42 0 0 1-3.2.45c-.16-.11-.06-.36.05-.52A5.33 5.33 0 0 0 359 417c-.53-6.94-.82-13.9-1.22-20.85Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "369.238px 411.409px"
    },
    id: "el1z24yxtmbnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.54 385.08c-2.2-3.51-5.62-12.94-8.43-22.94l-20.8 9.65S434 394.9 435.5 397c2.38 3.42 15.04-11.92 15.04-11.92Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "435.925px 379.819px"
    },
    id: "el0476qnxog7xq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.38 392.56c0-.2.08-1.86 0-2.06-.46-1.78-1.56-2.27-3-3.26a22 22 0 0 1-3.89-3.34c-.48-.65-.57-1-1.3-1.29-1.25-.51-3.27-.55-5.74.75-4.06 2.13-5.3 4.7-5.07 7.48.18 2.13.36 5-1.51 6.21-.78.52-2.65-2.08-2.65-2.08-1.15 1.93 1.11 3.82 2 7.74a16.07 16.07 0 0 1 .11 6.59c-.41 3.43-.88 3.42-2.71 3.66-1.57.21-6-.09-8.74 1.8-3.74 2.61-2.74 6.09-2.74 6.09.48 1.32 4.55 7.73 19.4 5.34 4.31-.7 13.37-7.47 13.23-8.11a8.4 8.4 0 0 1 0-1.94c.05-1.52.12-3 .19-4.56a23.27 23.27 0 0 1 .25-4.34 22.37 22.37 0 0 0 .55-3.59q.43-4.57.85-9.15c.12-.87.89-1.07.77-1.94Z",
    style: {
      fill: "#455a64",
      transformOrigin: "439.717px 404.499px"
    },
    id: "el77t0ew62qyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.25 392c1.47 1.41.58 5.53-1.39 10.47-.87 2.18-2.49 6-2 10s.56 5.9-.48 7.78c-1.61 2.94-10.25 6.7-15.34 7.88a28.18 28.18 0 0 0 5.18-14.7c.51-8.85 1.18-14.55 5.23-18.47 5.1-5.04 8.8-2.96 8.8-2.96Z",
    id: "elgohz0qxed7a",
    className: "animable",
    style: {
      transformOrigin: "450.011px 409.852px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14 420.85s3 5.58 14.47 5.4c4.53-.07 6.95-2.28 7.06-9.16.13-8.28.8-16.65 3.48-20.77s7-6.11 10.26-5.82a3.22 3.22 0 0 1 1.84 1.46s-3.31-1.09-8.47 3.19c-3.81 3.16-4.83 9.76-4.78 18 0 3.53.24 7.53-.79 10.2a8.13 8.13 0 0 1-5.49 4.84c-6.25 1.76-14.8-1.14-17-3.78a4.09 4.09 0 0 1-.58-3.56Z",
    style: {
      fill: "#37474f",
      transformOrigin: "440.607px 409.6px"
    },
    id: "elavyojts0d04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.94 411.45a2.39 2.39 0 0 0-.92 1.38 3.89 3.89 0 0 0 1.81 3.59c.69.44 1.29.28.19-1.17a7.2 7.2 0 0 1-1.08-3.8Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "436.318px 414.043px"
    },
    id: "el9siekoecrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.56 407.16s-.36.24-.45 1.39c-.05.62.91 3.11 2.12 3.7s.55-.8 0-1.49a9 9 0 0 1-1.67-3.6Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "437.51px 409.776px"
    },
    id: "elr4kynk62qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.16 402.43s-.4.1 0 1.69a5.07 5.07 0 0 0 2.51 2.2c.78.09 1.16-.3.2-1-.74-.54-2.57-2.13-2.71-2.89Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "437.711px 404.381px"
    },
    id: "elq8331nxrc8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 382.78S416.77 365 401.42 338a36 36 0 0 1-4.82-12.37c-1-4.5-6.38-27.17-6.38-27.17l-5.68 36.86c.82 3.94 2 10 2 14.54 0 6.09-.77 15.33-2.49 27.87-2.63 19.16-3.85 29.37-3.85 29.37-1.36 1-3 2.34-12.47 2.21-4.7-.07-9.64-2.68-9.64-2.68s-1.66-19.94-2.35-33.84c-.64-12.83-1.69-27.33-2.24-35.07-1-14.54-1.35-20.81-1.5-43.71-.15-23.76 1.66-58.71 1.66-58.71h66.88s4.95 8.35 3.59 28.81c.53 20 2.31 56.52 2.31 56.52 4.54 5.26 7.72 11.67 10.84 23.06 3.47 12.66 5.58 20 8.34 29.25-5.42-.15-16.62 6.06-18.62 9.84Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "398.806px 322.309px"
    },
    id: "el7u0w3qo91o6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.17 298.63 3.72-26.41s8.74-.67 19.25-9.41c0 0-1.39 7.82-16.29 13.17l-3.57 25.55 2.72 21.63s-5.77-24.03-5.83-24.53Z",
    style: {
      opacity: 0.2,
      transformOrigin: "401.655px 292.985px"
    },
    className: "animable",
    id: "eliu910w6wf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-149",
    className: "animable",
    style: {
      transformOrigin: "360.545px 169.788px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "389.88px 147.21px"
    },
    id: "elbdnxzv3acw",
    className: "animable",
    d: "m377.89 141.13 3.77 16.49 20.21-3-2.46-17.82-21.52 4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65 114.52a80 80 0 0 0-4.74 10l3.91 1.91Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "362.28px 120.475px"
    },
    id: "el5ckav6h3g3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.13 95.6c-7.1.37-9.34 7.51-10.28 23-.91 15 1 19.34 2.89 21.41 4.39 2.5 8.9 3 15.07 1.43 4.7-1.18 16.63-4.59 21.76-12 6-8.74 7.86-20.75 1.75-25.84-8.59-7.24-27.43-8.2-31.19-8Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "386.351px 118.957px"
    },
    id: "el1py7905rocu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.85 129.73a.57.57 0 0 0-.22.11 1.67 1.67 0 0 0-.12.16 2.87 2.87 0 0 1-.29.31 3.74 3.74 0 0 1-.7.56 5.31 5.31 0 0 1-1.54.58.11.11 0 0 0-.08.09.16.16 0 0 0 0 .15c.09.11.29.09.41.08a1.63 1.63 0 0 0 .44-.08 3.77 3.77 0 0 0 .92-.34 3.67 3.67 0 0 0 .76-.55 2.57 2.57 0 0 0 .33-.33 2.09 2.09 0 0 0 .14-.17.58.58 0 0 0 .1-.36c0-.06 0-.24-.15-.21Z",
    style: {
      fill: "#b16668",
      transformOrigin: "367.441px 130.752px"
    },
    id: "el0ibvfbrt0rxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.74 140c1.07 1.14 7.59 3 11.49 2.67l-.6-2.73a40.86 40.86 0 0 1-10.89.06Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "372.485px 141.324px"
    },
    id: "elt897v2d9zgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.47 106.24a5.87 5.87 0 0 0 .83 3.45 6.86 6.86 0 0 0 3.86 2.93 14 14 0 0 0-1.7 6.23 3.4 3.4 0 0 0 .38 2 1.27 1.27 0 0 0 2.3 0 16.51 16.51 0 0 1 2-3.23 6.19 6.19 0 0 1 3.92-2.07c5.69-.47 5.52 7.16 3.17 10.19-3.84 4.95-6.84 1.69-6.84 1.69s-2.08 7.7 3.32 11.12c0 0 8.74 2.22 14.84-.81 4-5.94 8.66-9.75 11.17-14.72 6-11.78 3.77-21.35-1.62-23.54-.6-4.84-4.95-7.92-9.18-9.55-5.76-2.22-11.45-.44-17.39-.58a19.71 19.71 0 0 1-8.73-2.27c-1.2-.63-2.66-1.38-3.79-.65a2.7 2.7 0 0 0-.95 1.27 6.25 6.25 0 0 0 .33 5.48c-1.53-1.16-4.3-.7-5.9.52-2.3 1.77-2.71 3.9-2 6.91.51 1.85 4.01 7.81 11.98 5.63Z",
    style: {
      fill: "#263238",
      transformOrigin: "387.737px 112.732px"
    },
    id: "el5d1syx3lgca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.76 100.65 5.49-3.06a3.14 3.14 0 0 0-5.49 3.06Z",
    style: {
      fill: "#263238",
      transformOrigin: "411.306px 98.3137px"
    },
    id: "elr66svmeouu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.61 147.36c9.52 0 13.14 2.14 16.06 5.56s17.12 26.1 20.8 36.87c1.74 5.1 1.26 7-3.1 12.19s-20.8 22.19-20.8 22.19l-8.21-12.41 10.45-15.32L408 171.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "425.51px 185.765px"
    },
    id: "elwjn3f6z926l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.85 149.45c5.87 2.88 9.73 10.83 8.92 22.79-.74 11.06-1.43 17.92-2.87 29.59a147.61 147.61 0 0 0-.59 21.92 167.11 167.11 0 0 0 1.9 17.31s-6.06 10.15-27 12c-25.29 2.24-43.13-6-43.13-6s.45-7.08.41-16.3c0-8.31-.59-18.36-.3-26.55.65-18.79.87-34.4 3-41.1 1.61-3.7 2.89-5.38 7.12-6.95 2.94-1.08 16.09-4.72 21.28-5.84 17.28-3.72 25.12-3.87 31.26-.87Z",
    style: {
      fill: "#37474f",
      transformOrigin: "388.979px 200.398px"
    },
    id: "elsrd57f26yr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42 152.87c2.65.67 4 2.22 7.95 3.11a30.72 30.72 0 0 0 18.05-1.31c3.74-1.58 4.71-4 4.71-4s-2.19-6.23-3-7.44a2.4 2.4 0 0 0-2-1.11l.22 1.59s.64 1.23-5 2.65-13.54 1.08-16.23.28l-.34-1.46c-1.39.37-2.23 1.51-3.81 3.66a46 46 0 0 0-3 4.64Z",
    style: {
      fill: "#455a64",
      transformOrigin: "388.55px 149.442px"
    },
    id: "elt9l9uze65a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.65 226.62c-5.71 1-8.47 2.81-11.23 3a14.79 14.79 0 0 1-3.93-.15l-3.2 3.87s-1.52-8.88.24-12.14 3-1.16 4.15-3.16 1-3.5 3.3-4.16 1.9-2.75 5.39-3.17 17.08 2.47 17.08 2.47Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "292.065px 222.004px"
    },
    id: "elrgix4ph9u1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89 155.64c-8 1.25-12.59 3.27-19.18 15.73-6.89 13-16.94 30.13-16.94 30.13l-30.12 7.34c-7 .6-13.11 14-7 19.62 0 0 26.91-1.18 35.57-1.54 14.85-.61 15-1.63 21-9.71s17.48-28.68 17.48-28.68 12.47-20.72-.81-32.89Z",
    style: {
      fill: "#455a64",
      transformOrigin: "330.075px 192.05px"
    },
    id: "ell7sgcwi8jms",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-149",
    className: "animable",
    style: {
      transformOrigin: "388.015px 48.7549px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "388.015px 48.7549px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "388.015px 48.7549px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.88 74.4 5.49-3.17a.55.55 0 0 0 .25-.23l1-1.77-2.77-1.6h-.4Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.25px 71.015px"
    },
    id: "elh69h64mq5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.88 74.4 5.49-3.17a.55.55 0 0 0 .25-.23l1-1.77-2.77-1.6h-.4Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "387.25px 71.015px"
    },
    className: "animable",
    id: "eltxrgu9f9qtb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.44 45-46.91-27.11a5.4 5.4 0 0 0-2.66-.64 5.33 5.33 0 0 0-2.65.64l-.58.35a5.86 5.86 0 0 0-2.64 4.59v25c0 1.69 0 3.06 2.4 4.42L379 62.5l4 11.61a.58.58 0 0 0 .54.38.57.57 0 0 0 .49-.29l3.79-6.57 20.68 12a5.5 5.5 0 0 0 2.66.63 5.44 5.44 0 0 0 2.65-.63l.58-.35a5.88 5.88 0 0 0 2.65-4.6v-25a5.86 5.86 0 0 0-2.6-4.68Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "388.02px 48.7549px"
    },
    id: "elux53lol3err",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08 22.08c.31-1.13 1.33-1.49 2.56-.78l46.92 27.15a5.31 5.31 0 0 1 1.86 2l5.89-3.45a5.5 5.5 0 0 0-1.87-2l-46.91-27.11a5.91 5.91 0 0 0-5.31 0l-.58.35a5.86 5.86 0 0 0-2.56 3.84Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.695px 33.855px"
    },
    id: "elzm6w7dot9wo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08 22.08c.31-1.13 1.33-1.49 2.56-.78l46.92 27.15a5.31 5.31 0 0 1 1.86 2l5.89-3.45a5.5 5.5 0 0 0-1.87-2l-46.91-27.11a5.91 5.91 0 0 0-5.31 0l-.58.35a5.86 5.86 0 0 0-2.56 3.84Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "387.695px 33.855px"
    },
    className: "animable",
    id: "elhwk6ucqg8qi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09 74.66a5.88 5.88 0 0 1-2.65 4.6l-.58.35a5.93 5.93 0 0 1-4.85.22c1.25.47 2.2-.24 2.2-1.75v-25a5.43 5.43 0 0 0-.78-2.62l5.88-3.46a5.43 5.43 0 0 1 .78 2.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "413.05px 63.6226px"
    },
    id: "elo6x9ag0ehkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09 74.66a5.88 5.88 0 0 1-2.65 4.6l-.58.35a5.93 5.93 0 0 1-4.85.22c1.25.47 2.2-.24 2.2-1.75v-25a5.43 5.43 0 0 0-.78-2.62l5.88-3.46a5.43 5.43 0 0 1 .78 2.61Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "413.05px 63.6226px"
    },
    className: "animable",
    id: "elkvuo24zbth"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45 21.94a1.4 1.4 0 0 1 .68.23l46.93 27.15a4.35 4.35 0 0 1 1.5 1.61 4.44 4.44 0 0 1 .64 2.07v25c0 .33-.06.89-.47.89a.92.92 0 0 1-.26 0h-.07l-.32-.16-20.68-12-.87-.5-.5.86-3.32 5.74L380 62.17l-.12-.35-.32-.18-17.67-10.24c-1.9-1.08-1.9-1.95-1.9-3.54v-25a2.85 2.85 0 0 1 0-.49c.11-.41.31-.41.41-.41m0-1a1.39 1.39 0 0 0-1.37 1.14c0-.19.08-.38.12-.57a4.72 4.72 0 0 0-.21 1.32v25c0 1.69 0 3.06 2.41 4.41L379 62.5l4 11.6a.55.55 0 0 0 .53.38.57.57 0 0 0 .49-.28l3.8-6.57 20.68 12a4.71 4.71 0 0 0 .45.22 1.06 1.06 0 0 0 .19.06 1.67 1.67 0 0 0 .53.08c.88 0 1.47-.69 1.47-1.89V53a5.85 5.85 0 0 0-2.64-4.59L361.64 21.3a2.38 2.38 0 0 0-1.19-.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "385.04px 50.465px"
    },
    id: "eltvv87kp7buc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.23 61.66a2.25 2.25 0 0 1-.72 1 1.62 1.62 0 0 1-1.06.34 2.62 2.62 0 0 1-1.3-.41 5.28 5.28 0 0 1-1.31-1.09 8.81 8.81 0 0 1-1.06-1.57 9.16 9.16 0 0 1-.71-1.82 7.35 7.35 0 0 1-.26-1.89 4.41 4.41 0 0 1 .26-1.59 2.27 2.27 0 0 1 .71-1 1.71 1.71 0 0 1 1.06-.33 2.65 2.65 0 0 1 1.31.41 5.24 5.24 0 0 1 1.3 1.09 7.86 7.86 0 0 1 1.06 1.57 9 9 0 0 1 .72 1.82 7.33 7.33 0 0 1 .25 1.89 4.42 4.42 0 0 1-.25 1.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "399.145px 58.1503px"
    },
    id: "el556q667zo8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.19 54.13a2.29 2.29 0 0 1-.72 1 1.67 1.67 0 0 1-1.06.33 2.62 2.62 0 0 1-1.3-.41 4.87 4.87 0 0 1-1.3-1.09 8 8 0 0 1-1.07-1.57 8.71 8.71 0 0 1-.71-1.82 7.35 7.35 0 0 1-.26-1.89 4.41 4.41 0 0 1 .23-1.58 2.24 2.24 0 0 1 .71-1 1.73 1.73 0 0 1 1.07-.34 2.65 2.65 0 0 1 1.3.41 5.08 5.08 0 0 1 1.3 1.1 7.51 7.51 0 0 1 1.06 1.56 9 9 0 0 1 .72 1.83 7.2 7.2 0 0 1 .25 1.88 4.42 4.42 0 0 1-.22 1.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "386.091px 50.6104px"
    },
    id: "el8j53imqqte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.15 46.6a2.27 2.27 0 0 1-.71 1 1.72 1.72 0 0 1-1.06.34 2.87 2.87 0 0 1-1.31-.41 5.29 5.29 0 0 1-1.3-1.1 7.51 7.51 0 0 1-1.06-1.56 9 9 0 0 1-.72-1.83 7.33 7.33 0 0 1-.25-1.89 4.42 4.42 0 0 1 .25-1.59 2.25 2.25 0 0 1 .72-1 1.68 1.68 0 0 1 1.06-.34 2.72 2.72 0 0 1 1.3.41 5.33 5.33 0 0 1 1.31 1.1 8.38 8.38 0 0 1 1.06 1.56 9 9 0 0 1 .71 1.83 7.34 7.34 0 0 1 .26 1.88 4.37 4.37 0 0 1-.26 1.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "373.075px 43.0798px"
    },
    id: "el6l9to64yy9m",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAdded);
export default __webpack_public_path__ + "static/media/noDataAdded.4178a09bb947ce5093dde509f53a3426.svg";
export { ForwardRef as ReactComponent };